<template>
  <div class="sport-event">
    <div class="first-line" v-if="$mq == 'sm'">
      <div class="sport-info">
        <div class="user-sports-wrap" style="position: relative;">
          <div class="user-sport-item">
            <div class="user-sport-image">
              <div class="sport-item__image" :class="this.sportEvent.sport_code"></div>
              <div class="sport-item__level">
                <div class="sport-item__level-wrap">
                  <span v-for="level in this.sport_event.sport_levels">{{ level }}</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3>{{ I18n.t(`sports.${this.sportEvent.sport_code}`) }}</h3>

            <div class="sport-level-description" v-for="level in this.sport_event.sport_levels">
              {{ I18n.t(`sport_events.levels.${level.toLowerCase()}`) }}
            </div>
          </div>

          <div v-if="['waiting', 'ready'].includes(sportEvent.status) && isUserCreator()" class="edit-link" style="position: absolute; top: 0; right: 0;">
            <a :href="`/sport_events/${this.sportEvent.id}/edit`" class="btn btn-sm cta-btn edit-button">
              <font-awesome-icon icon="cogs" size="lg" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="lg-left-side">
      <div class="common-info" v-if="this.isShowCommonInfoDefault">
        <div class="datetime-info">
          <div class="datetime-info-wrap">
            <div class="datetime-info-img">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.1" width="48" height="48" rx="12" fill="#5669FF"/>
                <path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M20.1838 15.3519H27.8621V13.5641H20.1838V15.3519ZM18.4371 13.6375V13.6464C17.8377 13.7009 17.2447 13.82 16.6679 13.9991V13.9924C16.6507 13.9996 16.6346 14.0052 16.6191 14.0105C16.5987 14.0175 16.5795 14.0241 16.5606 14.0336C16.5145 14.0447 16.4695 14.0614 16.4266 14.0825C16.3001 14.1237 16.1736 14.1726 16.0545 14.2227C16.0229 14.2349 15.9913 14.2491 15.9596 14.2633C15.928 14.2775 15.8964 14.2916 15.8648 14.3039C15.8213 14.3245 15.776 14.347 15.7307 14.3695C15.6854 14.3921 15.6401 14.4146 15.5967 14.4352L15.3822 14.5586C15.3426 14.5789 15.3059 14.6026 15.2684 14.6268C15.2461 14.6412 15.2236 14.6558 15.2 14.6699C14.8772 14.8779 14.5781 15.1216 14.3079 15.3986L14.2918 15.4153C14.2563 15.4566 14.2209 15.4968 14.1861 15.5364C14.1272 15.6033 14.0697 15.6686 14.0151 15.7357L13.999 15.7512C13.122 16.9616 12.6823 18.4535 12.7585 19.9653V20.4448H14.4901V19.9609C14.4901 17.8538 15.1614 16.5422 16.655 15.8703C17.2254 15.6289 17.828 15.4798 18.4414 15.4253H18.4574V13.6453L18.4371 13.6375ZM33.9975 15.729L34.005 15.7446C34.881 16.9561 35.3185 18.449 35.2413 19.9609V20.4448H33.5107V19.9487C33.5471 19.0564 33.3681 18.1687 32.9885 17.3666C32.6239 16.6802 32.0406 16.1473 31.3362 15.858C30.7754 15.6166 30.1814 15.4664 29.5755 15.413V13.642C30.1749 13.6976 30.7679 13.8155 31.3458 13.9946V13.9857C31.3783 14.0005 31.4031 14.0092 31.4456 14.0242L31.453 14.0269C31.4728 14.0339 31.4912 14.0408 31.5094 14.0477C31.5347 14.0573 31.5596 14.0668 31.5871 14.0758C31.7056 14.1147 31.8165 14.1606 31.9306 14.2077L31.9506 14.216C32.0032 14.2345 32.0528 14.2574 32.0975 14.2781C32.1119 14.2848 32.1259 14.2912 32.1393 14.2972C32.2336 14.3384 32.3301 14.3873 32.4073 14.4285C32.4588 14.4552 32.509 14.4838 32.556 14.5106C32.5814 14.5251 32.606 14.5391 32.6293 14.552C32.6677 14.5732 32.7011 14.5959 32.7332 14.6177C32.7567 14.6337 32.7795 14.6491 32.803 14.6632C33.1268 14.8724 33.4292 15.1171 33.7026 15.3919L33.7123 15.4086C33.813 15.5098 33.9085 15.6166 33.9975 15.729Z" fill="#5669FF"/>
                <path d="M29.6252 12.3962V16.3356C29.6252 16.8319 29.2225 17.234 28.7252 17.234C28.228 17.234 27.8252 16.8319 27.8252 16.3356V12.4051C27.8207 11.9088 28.2212 11.5034 28.7185 11.5C29.2157 11.4967 29.6219 11.8953 29.6252 12.3917V12.3962Z" fill="#5669FF"/>
                <path d="M20.175 12.4105V16.3402C20.175 16.8387 19.7718 17.2429 19.2744 17.2429C18.7771 17.2429 18.375 16.8387 18.375 16.3402V12.4105C18.375 11.912 18.7771 11.5089 19.2744 11.5089C19.7718 11.5089 20.175 11.912 20.175 12.4105Z" fill="#5669FF"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 30.1376V20.4448H35.25V30.1376C35.25 34.3644 32.8895 36.4999 28.2114 36.4999H19.7779C15.1105 36.4999 12.75 34.3644 12.75 30.1376ZM17.8251 25.8334C17.8251 26.4198 18.2865 26.8956 18.8552 26.8956C19.4346 26.8956 19.8959 26.4088 19.8852 25.8223C19.8852 25.2359 19.4238 24.7601 18.8659 24.7601H18.8552C18.2865 24.7601 17.8251 25.247 17.8251 25.8334ZM22.9646 25.8334C22.9646 26.4198 23.4367 26.8956 24.0054 26.8956C24.574 26.8956 25.0354 26.4198 25.0354 25.8223C25.0354 25.247 24.574 24.7712 24.0054 24.7601H23.9946C23.426 24.7712 22.9646 25.247 22.9646 25.8334ZM29.1449 26.8956C28.5762 26.8956 28.1148 26.4198 28.1148 25.8334C28.1148 25.247 28.5655 24.7712 29.1449 24.7712C29.7135 24.7712 30.1749 25.247 30.1749 25.8334C30.1749 26.4198 29.7135 26.8956 29.1449 26.8956ZM29.1449 31.4322C28.5762 31.4322 28.1148 30.9564 28.1041 30.37C28.1041 29.7836 28.5655 29.3078 29.1341 29.3078H29.1449C29.7135 29.3078 30.1749 29.7836 30.1749 30.37C30.1749 30.9564 29.7135 31.4322 29.1449 31.4322ZM24.0054 31.4322C23.4367 31.4322 22.9646 30.9564 22.9646 30.37C22.9646 29.7836 23.426 29.3078 23.9946 29.2967H24.0054C24.574 29.3078 25.0247 29.7836 25.0354 30.3589C25.0354 30.9564 24.574 31.4322 24.0054 31.4322ZM18.8552 31.4322C18.2865 31.4322 17.8251 30.9564 17.8251 30.37C17.8144 29.7836 18.2758 29.2967 18.8552 29.2967C19.4238 29.2967 19.8852 29.7725 19.8852 30.3589C19.8852 30.9454 19.4238 31.4322 18.8552 31.4322Z" fill="#5669FF"/>
              </svg>
            </div>

            <div class="datetime-info__date-wrap">
              <div class="datetime-info__date">
                <div>
                  {{ this.sportEvent.start_date_formatted }}
                </div>
                <div class=datetime-remaining v-if="$mq != 'sm' && isWaitingForParticipants">{{ this.sportEvent.start_after_in_words }}</div>
              </div>

              <div class="datetime-info__time">
                <div>
                  {{ I18n.t("prefixes.from") }} {{ sportEventStartAtMinutes() }} {{ I18n.t("prefixes.till") }} {{ sportEvent.finished_at_time }}
                </div>
              </div>
            </div>
          </div>

          <div class=datetime-remaining v-if="$mq == 'sm' && isWaitingForParticipants">{{ this.sportEvent.start_after_in_words }}</div>
        </div>

        <div class="place-info">
          <div class="place-info-wrap">
            <div class="place-info-img">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.12" width="48" height="48" rx="12" fill="#5669FF"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6645 12.671C22.3956 11.0841 25.7525 11.1118 28.458 12.7436C31.1368 14.4086 32.765 17.3802 32.7498 20.5768C32.6874 23.7524 30.9416 26.7375 28.7593 29.0451C27.4998 30.383 26.0908 31.566 24.5611 32.57C24.4035 32.6611 24.2309 32.7221 24.0519 32.75C23.8795 32.7427 23.7116 32.6917 23.5634 32.6018C21.228 31.0932 19.1792 29.1675 17.5154 26.9175C16.1232 25.0392 15.3323 22.77 15.25 20.418C15.2482 17.2153 16.9335 14.2578 19.6645 12.671ZM21.2427 21.7434C21.7021 22.876 22.7865 23.6147 23.9895 23.6147C24.7776 23.6204 25.5352 23.3047 26.0935 22.738C26.6518 22.1713 26.9644 21.4007 26.9616 20.5979C26.9658 19.3725 26.2443 18.2653 25.1341 17.7934C24.0238 17.3215 22.7438 17.5779 21.8916 18.4429C21.0395 19.3079 20.7833 20.6108 21.2427 21.7434Z" fill="#5669FF"/>
                <path opacity="0.4" d="M24 36.5C27.4518 36.5 30.25 35.9404 30.25 35.25C30.25 34.5596 27.4518 34 24 34C20.5482 34 17.75 34.5596 17.75 35.25C17.75 35.9404 20.5482 36.5 24 36.5Z" fill="#5669FF"/>
              </svg>
            </div>

            <div class="place-info__court-address">
              <div class="place-info__court">
                <div>{{ sportEvent.place_name }}</div>

                <div class="place-info__booking" v-if="$mq != 'sm'">
                  <div class="place-info__booking--booked" data-toggle="tooltip" :title="I18n.t('sport_events.show.booking.booked')" v-if="this.sportEvent.booked">
                    <font-awesome-icon icon="lock" size="lg" />
                  </div>
                  <div class="place-info__booking--not-booked" data-toggle="tooltip" :title="I18n.t('sport_events.show.booking.not_booked')" v-else>
                    <font-awesome-icon icon="unlock" size="lg" />
                  </div>
                </div>
              </div>

              <div class="place-info__address" style="margin-bottom: 6px;">
                <a :class="placeCss()" v-on:click.prevent.stop="openPlaceMapModal()" style="cursor: pointer;">
                  {{ sportEvent.place }}
                </a>
              </div>

              <div class="place-info__address__more-info" v-if="this.sportEvent.additional_place_info_exists">
                <a class="light-link" :href="`/sport_events/${this.sportEvent.id}/place_info`" style="color: #679fb3;">
                  {{ I18n.t('sport_event.place.show_more_link') }}
                </a>
              </div>
            </div>

            <div class="place-info__booking" v-if="$mq == 'sm'">
              <div class="place-info__booking--booked" data-toggle="tooltip" :title="I18n.t('sport_events.show.booking.booked')" v-if="this.sportEvent.booked">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.74999 1.25C9.75664 1.25007 10.753 1.45279 11.6796 1.84608C12.6063 2.23936 13.4443 2.81517 14.1437 3.53918C14.843 4.26318 15.3895 5.12058 15.7506 6.06027C16.1116 6.99995 16.2797 8.0027 16.245 9.00875C15.813 8.82106 15.3442 8.73343 14.8736 8.75243C14.403 8.77143 13.9428 8.89656 13.5273 9.11846C13.1119 9.34037 12.752 9.65331 12.4745 10.0339C12.197 10.4145 12.0092 10.8528 11.925 11.3163C11.3769 11.4458 10.8886 11.7566 10.5392 12.1983C10.1898 12.64 9.99982 13.1868 9.99999 13.75V16.1462C8.97714 16.3182 7.92976 16.2761 6.92401 16.0226C5.91826 15.7691 4.97601 15.3098 4.15681 14.6737C3.33761 14.0375 2.65927 13.2384 2.16463 12.3267C1.67 11.415 1.36983 10.4107 1.2831 9.37715C1.19637 8.34358 1.32496 7.30326 1.66075 6.32192C1.99653 5.34059 2.53221 4.43956 3.23394 3.67579C3.93567 2.91201 4.78819 2.30208 5.73763 1.88455C6.68707 1.46701 7.7128 1.25095 8.74999 1.25V1.25ZM11.4 6.455L7.81249 10.0525L6.06749 8.3075C6.00938 8.24939 5.9404 8.20329 5.86447 8.17185C5.78855 8.1404 5.70717 8.12421 5.62499 8.12421C5.54281 8.12421 5.46144 8.1404 5.38551 8.17185C5.30959 8.20329 5.2406 8.24939 5.18249 8.3075C5.12438 8.36561 5.07829 8.4346 5.04684 8.51052C5.01539 8.58644 4.9992 8.66782 4.9992 8.75C4.9992 8.83218 5.01539 8.91356 5.04684 8.98948C5.07829 9.0654 5.12438 9.13439 5.18249 9.1925L7.36999 11.38C7.42805 11.4382 7.49702 11.4844 7.57295 11.5159C7.64888 11.5474 7.73028 11.5636 7.81249 11.5636C7.8947 11.5636 7.9761 11.5474 8.05204 11.5159C8.12797 11.4844 8.19694 11.4382 8.25499 11.38L12.285 7.3375C12.3987 7.21946 12.4615 7.0615 12.4598 6.89762C12.4582 6.73374 12.3922 6.57707 12.2762 6.46135C12.1601 6.34563 12.0033 6.28012 11.8394 6.27893C11.6755 6.27774 11.5177 6.34097 11.4 6.455V6.455ZM13.0375 12.5C13.0671 12.4985 13.0966 12.4976 13.1262 12.4975V11.88C13.1262 11.3827 13.3238 10.9058 13.6754 10.5542C14.027 10.2025 14.504 10.005 15.0012 10.005C15.4985 10.005 15.9754 10.2025 16.3271 10.5542C16.6787 10.9058 16.8762 11.3827 16.8762 11.88V12.4975H16.88C16.9112 12.4975 16.9425 12.4975 16.9737 12.5H17.5C17.8315 12.5 18.1495 12.6317 18.3839 12.8661C18.6183 13.1005 18.75 13.4185 18.75 13.75V14.2375C18.7537 14.2813 18.755 14.3263 18.755 14.3725V16.875C18.755 16.9213 18.7537 16.9663 18.75 17.0113V17.5C18.75 17.8315 18.6183 18.1495 18.3839 18.3839C18.1495 18.6183 17.8315 18.75 17.5 18.75H12.5C12.1685 18.75 11.8505 18.6183 11.6161 18.3839C11.3817 18.1495 11.25 17.8315 11.25 17.5V13.75C11.25 13.4185 11.3817 13.1005 11.6161 12.8661C11.8505 12.6317 12.1685 12.5 12.5 12.5H13.0375ZM15 11.255C14.8342 11.255 14.6753 11.3208 14.5581 11.4381C14.4408 11.5553 14.375 11.7142 14.375 11.88V12.4975H15.625V11.88C15.625 11.7142 15.5591 11.5553 15.4419 11.4381C15.3247 11.3208 15.1658 11.255 15 11.255ZM15.625 15.625C15.625 15.4592 15.5591 15.3003 15.4419 15.1831C15.3247 15.0658 15.1658 15 15 15C14.8342 15 14.6753 15.0658 14.5581 15.1831C14.4408 15.3003 14.375 15.4592 14.375 15.625C14.375 15.7908 14.4408 15.9497 14.5581 16.0669C14.6753 16.1842 14.8342 16.25 15 16.25C15.1658 16.25 15.3247 16.1842 15.4419 16.0669C15.5591 15.9497 15.625 15.7908 15.625 15.625Z" fill="black"/>
                </svg>
              </div>
              <div class="place-info__booking--not-booked" data-toggle="tooltip" :title="I18n.t('sport_events.show.booking.not_booked')" v-else>
                <font-awesome-icon icon="unlock" size="lg" />
              </div>
            </div>
          </div>
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center;" v-if="$mq == 'sm'">
          <div class="price">
            <div v-if="sportEvent.price > 0">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.6 9C10.2 8.9 9.8 8.7 9.5 8.4C9.2 8.3 9.1 8 9.1 7.8C9.1 7.6 9.2 7.3 9.4 7.2C9.7 7 10 6.8 10.3 6.9C10.9 6.9 11.4 7.2 11.7 7.6L12.6 6.4C12.3 6.1 12 5.9 11.7 5.7C11.4 5.5 11 5.4 10.6 5.4V4H9.4V5.4C8.9 5.5 8.4 5.8 8 6.2C7.6 6.7 7.3 7.3 7.4 7.9C7.4 8.5 7.6 9.1 8 9.5C8.5 10 9.2 10.3 9.8 10.6C10.1 10.7 10.5 10.9 10.8 11.1C11 11.3 11.1 11.6 11.1 11.9C11.1 12.2 11 12.5 10.8 12.8C10.5 13.1 10.1 13.2 9.8 13.2C9.4 13.2 8.9 13.1 8.6 12.8C8.3 12.6 8 12.3 7.8 12L6.8 13.1C7.1 13.5 7.4 13.8 7.8 14.1C8.3 14.4 8.9 14.7 9.5 14.7V16H10.6V14.5C11.2 14.4 11.7 14.1 12.1 13.7C12.6 13.2 12.9 12.4 12.9 11.7C12.9 11.1 12.7 10.4 12.2 10C11.7 9.5 11.2 9.2 10.6 9V9ZM10 2C5.6 2 2 5.6 2 10C2 14.4 5.6 18 10 18C14.4 18 18 14.4 18 10C18 5.6 14.4 2 10 2ZM10 16.9C6.2 16.9 3.1 13.8 3.1 10C3.1 6.2 6.2 3.1 10 3.1C13.8 3.1 16.9 6.2 16.9 10C16.9 13.8 13.8 16.9 10 16.9V16.9Z" fill="black"/>
              </svg>

              <span class="price-amount">{{ `${sportEvent.price} ${sportEvent.currency}` }}</span>
              <div class="price-description">{{ I18n.t('sport_events.one_person_price') }}</div>
            </div>

            <div v-else>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.6 9C10.2 8.9 9.8 8.7 9.5 8.4C9.2 8.3 9.1 8 9.1 7.8C9.1 7.6 9.2 7.3 9.4 7.2C9.7 7 10 6.8 10.3 6.9C10.9 6.9 11.4 7.2 11.7 7.6L12.6 6.4C12.3 6.1 12 5.9 11.7 5.7C11.4 5.5 11 5.4 10.6 5.4V4H9.4V5.4C8.9 5.5 8.4 5.8 8 6.2C7.6 6.7 7.3 7.3 7.4 7.9C7.4 8.5 7.6 9.1 8 9.5C8.5 10 9.2 10.3 9.8 10.6C10.1 10.7 10.5 10.9 10.8 11.1C11 11.3 11.1 11.6 11.1 11.9C11.1 12.2 11 12.5 10.8 12.8C10.5 13.1 10.1 13.2 9.8 13.2C9.4 13.2 8.9 13.1 8.6 12.8C8.3 12.6 8 12.3 7.8 12L6.8 13.1C7.1 13.5 7.4 13.8 7.8 14.1C8.3 14.4 8.9 14.7 9.5 14.7V16H10.6V14.5C11.2 14.4 11.7 14.1 12.1 13.7C12.6 13.2 12.9 12.4 12.9 11.7C12.9 11.1 12.7 10.4 12.2 10C11.7 9.5 11.2 9.2 10.6 9V9ZM10 2C5.6 2 2 5.6 2 10C2 14.4 5.6 18 10 18C14.4 18 18 14.4 18 10C18 5.6 14.4 2 10 2ZM10 16.9C6.2 16.9 3.1 13.8 3.1 10C3.1 6.2 6.2 3.1 10 3.1C13.8 3.1 16.9 6.2 16.9 10C16.9 13.8 13.8 16.9 10 16.9V16.9Z" fill="black"/>
              </svg>
              <span class="price-amount">{{ I18n.t("sport_events.show.free_price") }}</span>
            </div>
          </div>

          <div class="share-link" v-on:click.prevent.stop="openShareLinkModal()" v-if="sportEvent.status == 'waiting' && isUserCreator()">
            <div class="share-link-wrap">
              <a href="" :class="shareLinkClass()">
                <font-awesome-icon icon="link" size="lg" />
                {{ I18n.t("sport_events.share_link.share") }}
              </a>
            </div>
          </div>
        </div>

        <div v-if="!!this.sportEvent.comment" class="comment">
          <p>{{ this.sportEvent.comment }}</p>
        </div>

        <div v-if="this.isShowCommonInfo === true" v-on:click.prevent.stop="changeShowCommonInfo(false)" class="show-less-event-info">
          <a href="" class="btn btn-sm cta-btn">
            <font-awesome-icon icon="arrow-up" />
            {{ I18n.t("sport_events.show.hide_common_info") }}
          </a>
        </div>
      </div>

      <div v-else style="margin-top: 24px;" class="show-more-event-info" v-on:click.prevent.stop="changeShowCommonInfo(true)">
        <a href="" class="btn btn-sm cta-btn">
          <font-awesome-icon icon="arrow-down"/>
          {{ I18n.t("sport_events.show.show_common_info") }}
        </a>
      </div>

      <div v-if="sportEvent.sport_competitions.length > 0" style="padding: 24px 0px;">
        <div style="font-weight: 450; font-size: 15px;">
          {{ I18n.t("sport_events.show.sport_competitions.titles.active_competitions") }}
         </div>

        <div v-for="competition in sportEvent.sport_competitions" style="margin-top: 24px;">
          <div style="display: flex; margin-top: 24px;">
            <div style="display: flex; align-items: center;">
              <a :href="`/users/${competition.requested_user.nickname}`">
                <img style="margin-right: 24px" :src="avatarPath(competition.requested_user)" width="30" height="30" alt="profile photo" class="user-partner-avatar-icon" loading="lazy">
              </a>
              <div style="font-size: 30px">
                {{ competition.requested_user_wins }}
              </div>
            </div>
            <div style="display: flex; align-items: center; margin-right: 6px; margin-left: 6px;">:</div>
            <div style="display: flex; align-items: center; margin-right: 24px;">
              <div style="font-size: 30px">
                {{ competition.initiated_user_wins }}
              </div>
              <a :href="`/users/${competition.initiator.nickname}`">
                <img style="margin-left: 24px" :src="avatarPath(competition.initiator)" width="30" height="30" alt="profile photo" class="user-partner-avatar-icon" loading="lazy">
              </a>
            </div>
          </div>
          <div style="font-size: 13px; color: grey; margin-top: 12px;">до {{ competition.count_of_wins }} побед</div>
        </div>
      </div>

      <div v-if="sportEvent.status == 'finished' && sportEvent.sport_competition_results.length > 0" class="sport-event__competition-results-wrap">
        <div style="font-weight: 600;">
          {{ I18n.t("sport_events.show.sport_competitions.titles.competition_results") }}
        </div>
        <div v-for="result in sportEvent.sport_competition_results">
          <sport-competition-result-submission :currentUserId="user.id" :result="result" :sportEventPage="true" />
        </div>
      </div>

      <div v-if="this.sportEvent.status == 'finished'" class="sport-event__review-wrap">
        <a :href="`/sport_events/${this.sportEvent.id}/review`" class="btn cta-btn purple btn-large">
          {{ I18n.t("sport_events.show.reviews_button", { reviews_count: this.sportEvent.reviews_count > 0 ? this.sportEvent.reviews_count : "" }) }}

          <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 5px;">
            <path d="M1 1L6 5.73684L1 10" stroke="white" stroke-width="2"/>
          </svg>
        </a>
      </div>

      <div class="participation-actions">
        <div v-if="!isUserCreator()">
          <div v-if="isCreatorMakeRequestForUser && isWaitingForParticipants" class="request-from-creator-info-wrap">
            <div class="sport-event__actions--requested-participant">
              <div>
                <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M36.2127 10.3505H5.18387C3.80896 10.3505 2.69434 11.4651 2.69434 12.84V39.4148C2.69434 40.7897 3.80896 41.9043 5.18387 41.9043H14.7879C15.7514 41.9043 16.6285 42.4603 17.0395 43.3318L20.1353 49.8958C20.3598 50.3716 21.0364 50.3723 21.2608 49.8965C21.9526 48.4296 23.1804 45.8266 24.3573 43.3313C24.7683 42.46 25.645 41.9043 26.6084 41.9043H36.2127C37.5876 41.9043 38.7022 40.7897 38.7022 39.4148V12.84C38.7022 11.4651 37.5876 10.3505 36.2127 10.3505Z" fill="#DD636E"/>
                  <path d="M5.49623 39.4147V12.8399C5.49623 11.465 6.61086 10.3503 7.98566 10.3503H5.18475C3.80984 10.3503 2.69531 11.465 2.69531 12.8399V39.4147C2.69531 40.7896 3.80994 41.9041 5.18475 41.9041H7.98566C6.61076 41.9042 5.49623 40.7896 5.49623 39.4147Z" fill="#C63D4F"/>
                  <path d="M19.8401 43.3318C19.4291 42.4603 18.552 41.9043 17.5885 41.9043H14.7876C15.7511 41.9043 16.6282 42.4603 17.0392 43.3318L20.135 49.8958C20.3594 50.3716 21.0361 50.3723 21.2605 49.8965C21.4885 49.413 21.775 48.8056 22.0984 48.1199L19.8401 43.3318Z" fill="#C63D4F"/>
                  <path d="M36.2126 10.3505H26.6084C26.6084 17.0189 32.0336 22.4441 38.7021 22.4441V12.84C38.7022 11.4651 37.5875 10.3505 36.2126 10.3505Z" fill="#C63D4F"/>
                  <path d="M38.7021 19.9539C44.0059 19.9539 48.3055 15.6543 48.3055 10.3505C48.3055 5.04668 44.0059 0.74707 38.7021 0.74707C33.3982 0.74707 29.0986 5.04668 29.0986 10.3505C29.0986 15.6543 33.3982 19.9539 38.7021 19.9539Z" fill="#FFD064"/>
                  <path d="M31.5889 10.3505C31.5889 5.46865 35.2316 1.43786 39.9472 0.827256C39.5396 0.774463 39.124 0.74707 38.7021 0.74707C33.3983 0.74707 29.0986 5.04671 29.0986 10.3505C29.0986 15.6543 33.3983 19.9539 38.7021 19.9539C39.124 19.9539 39.5396 19.9265 39.9472 19.8738C35.2317 19.2632 31.5889 15.2324 31.5889 10.3505Z" fill="#EBB044"/>
                  <path d="M27.6373 34.9992H13.7598V28.6649C13.7598 27.0696 15.0531 25.7762 16.6484 25.7762H24.7487C26.344 25.7762 27.6373 27.0696 27.6373 28.6649V34.9992Z" fill="#90D8F9"/>
                  <path d="M18.7638 25.7764H16.6484C15.0531 25.7764 13.7598 27.0697 13.7598 28.665V34.9993H15.8752V28.665C15.8752 27.0696 17.1685 25.7764 18.7638 25.7764Z" fill="#75CEF9"/>
                  <path d="M20.6984 25.7764C18.3454 25.7764 16.438 23.869 16.438 21.516C16.438 19.163 18.3454 17.2556 20.6984 17.2556C23.0514 17.2556 24.9588 19.163 24.9588 21.516C24.9587 23.869 23.0513 25.7764 20.6984 25.7764V25.7764Z" fill="#FFB8A9"/>
                  <path d="M18.553 21.5159C18.553 19.5281 19.9145 17.8585 21.7556 17.3881C21.4174 17.3017 21.0631 17.2556 20.6979 17.2556C18.3449 17.2556 16.4375 19.163 16.4375 21.516C16.4375 23.869 18.3449 25.7764 20.6979 25.7764C21.0631 25.7764 21.4174 25.7303 21.7556 25.6439C19.9145 25.1734 18.553 23.5037 18.553 21.5159V21.5159Z" fill="#FF947E"/>
                  <path d="M38.7022 23.5935C38.2896 23.5935 37.9552 23.928 37.9552 24.3406V39.4148C37.9552 40.3756 37.1735 41.1573 36.2128 41.1573H26.6085C25.3621 41.1573 24.2133 41.8856 23.6817 43.0127L20.6984 49.338L17.7153 43.0131C17.1836 41.8857 16.0345 41.1572 14.788 41.1572H5.18387C4.22304 41.1572 3.44141 40.3755 3.44141 39.4147V20.7905C3.44141 20.3779 3.10692 20.0435 2.69434 20.0435C2.28175 20.0435 1.94727 20.3779 1.94727 20.7905V39.4148C1.94727 41.1995 3.39917 42.6514 5.18387 42.6514H14.7879C15.459 42.6514 16.0776 43.0436 16.3638 43.6505L19.4597 50.2144C19.6882 50.699 20.1629 51.0001 20.6986 51.0001C21.2338 51.0001 21.7082 50.6992 21.9366 50.2151L25.0329 43.6501C25.3191 43.0434 25.9375 42.6514 26.6084 42.6514H36.2127C37.9973 42.6514 39.4492 41.1995 39.4492 39.4148V24.3406C39.4493 23.928 39.1148 23.5935 38.7022 23.5935V23.5935Z" fill="black"/>
                  <path d="M2.69434 18.0026C3.10692 18.0026 3.44141 17.6681 3.44141 17.2555V12.8399C3.44141 11.8792 4.22304 11.0975 5.18387 11.0975H25.5C25.9126 11.0975 26.2471 10.763 26.2471 10.3505C26.2471 9.93788 25.9126 9.60339 25.5 9.60339H5.18387C3.39917 9.60339 1.94727 11.0553 1.94727 12.8399V17.2555C1.94727 17.6682 2.28175 18.0026 2.69434 18.0026Z" fill="black"/>
                  <path d="M47.0643 4.24983C46.8208 3.91664 46.3535 3.84403 46.0203 4.08737C45.6872 4.33082 45.6145 4.79818 45.8578 5.13128C46.9702 6.65371 47.5583 8.45853 47.5583 10.3505C47.5583 15.2339 43.5854 19.2069 38.702 19.2069C33.8185 19.2069 29.8456 15.234 29.8456 10.3505C29.8456 5.46706 33.8186 1.49414 38.7021 1.49414C40.2788 1.49414 41.8265 1.9134 43.1779 2.70659C43.5337 2.91547 43.9915 2.79633 44.2004 2.44043C44.4093 2.08462 44.2901 1.62682 43.9343 1.41794C42.3537 0.490277 40.5443 0 38.7021 0C32.9948 0 28.3516 4.64319 28.3516 10.3505C28.3516 16.0577 32.9948 20.701 38.7021 20.701C44.4094 20.701 49.0526 16.0578 49.0526 10.3505C49.0526 8.13938 48.365 6.02985 47.0643 4.24983Z" fill="black"/>
                  <path d="M38.7022 15.2574C39.1148 15.2574 39.4492 14.9229 39.4492 14.5103V11.0977H42.8619C43.2744 11.0977 43.6089 10.7632 43.6089 10.3506C43.6089 9.93802 43.2744 9.60354 42.8619 9.60354H39.4492V6.19092C39.4492 5.77834 39.1148 5.44385 38.7022 5.44385C38.2896 5.44385 37.9551 5.77834 37.9551 6.19092V9.60354H34.5425C34.1299 9.60354 33.7954 9.93802 33.7954 10.3506C33.7954 10.7632 34.1299 11.0977 34.5425 11.0977H37.9551V14.5103C37.9551 14.9229 38.2895 15.2574 38.7022 15.2574Z" fill="black"/>
                  <path d="M24.7482 25.0293H24.262C25.1539 24.1247 25.7056 22.8837 25.7056 21.516C25.7056 18.7549 23.4592 16.5085 20.6981 16.5085C17.9371 16.5085 15.6907 18.7548 15.6907 21.516C15.6907 22.8837 16.2424 24.1247 17.1343 25.0293H16.6479C14.6432 25.0293 13.0122 26.6603 13.0122 28.6651V34.2522H9.97607C9.56349 34.2522 9.229 34.5867 9.229 34.9992C9.229 35.4118 9.56349 35.7463 9.97607 35.7463H31.42C31.8326 35.7463 32.1671 35.4118 32.1671 34.9992C32.1671 34.5867 31.8326 34.2522 31.42 34.2522H28.3839V28.6651C28.384 26.6603 26.753 25.0293 24.7482 25.0293V25.0293ZM17.1848 21.516C17.1848 19.5788 18.7609 18.0027 20.6981 18.0027C22.6353 18.0027 24.2114 19.5787 24.2114 21.516C24.2114 23.4533 22.6353 25.0293 20.6981 25.0293C18.7608 25.0293 17.1848 23.4533 17.1848 21.516ZM14.5064 28.6651C14.5064 27.4842 15.4671 26.5235 16.648 26.5235H24.7482C25.9291 26.5235 26.8898 27.4842 26.8898 28.6651V34.2522H14.5064V28.6651Z" fill="black"/>
                </svg>

                {{ I18n.t("sport_events.show.request_from_creator_info") }}

                <div class="request-from-creator-info-accept-button-wrap">
                  <button v-on:click.prevent.stop="participationRequest('request_from_creator_accepted')" class="btn cta-btn purple" >
                    {{ I18n.t("sport_events.show.event_accept_creator_request_button")}}
                  </button>
                </div>

                <div style="margin-top: 12px;" class="reject-participation">
                  <a href="" v-on:click.prevent.stop="openRejectParticipationModal()" class="text-danger">
                    {{ I18n.t("sport_events.show.participation_reject_without_previous_accept_button")}}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="sport-event__actions--not-participant">
            <div v-if="isUserCanParticipate && is_creator_know_current_user" class="participation-request-wrap">
              <div>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.3335 0.333374H1.66683C1.31321 0.333374 0.974069 0.47385 0.72402 0.723898C0.473972 0.973947 0.333496 1.31309 0.333496 1.66671V18.3334C0.333496 18.687 0.473972 19.0261 0.72402 19.2762C0.974069 19.5262 1.31321 19.6667 1.66683 19.6667H18.3335C18.6871 19.6667 19.0263 19.5262 19.2763 19.2762C19.5264 19.0261 19.6668 18.687 19.6668 18.3334V1.66671C19.6668 1.31309 19.5264 0.973947 19.2763 0.723898C19.0263 0.47385 18.6871 0.333374 18.3335 0.333374ZM11.3335 16.3334H8.66683V8.33337H11.3335V16.3334ZM10.0002 7.00004C9.73645 7.00004 9.47867 6.92184 9.2594 6.77533C9.04014 6.62882 8.86924 6.42059 8.76832 6.17695C8.66741 5.93332 8.641 5.66523 8.69245 5.40659C8.7439 5.14795 8.87088 4.91037 9.05735 4.7239C9.24382 4.53743 9.4814 4.41044 9.74004 4.35899C9.99868 4.30755 10.2668 4.33395 10.5104 4.43487C10.754 4.53578 10.9623 4.70668 11.1088 4.92595C11.2553 5.14521 11.3335 5.403 11.3335 5.66671C11.3335 6.02033 11.193 6.35947 10.943 6.60952C10.6929 6.85956 10.3538 7.00004 10.0002 7.00004V7.00004Z" fill="#9BC9FF"/>
                  <path d="M18.3333 20H1.66667C1.2248 19.9995 0.801186 19.8237 0.48874 19.5113C0.176294 19.1988 0.000529286 18.7752 0 18.3333V1.66667C0.000529286 1.2248 0.176294 0.801186 0.48874 0.48874C0.801186 0.176294 1.2248 0.000529286 1.66667 0H18.3333C18.7752 0.000529286 19.1988 0.176294 19.5113 0.48874C19.8237 0.801186 19.9995 1.2248 20 1.66667V18.3333C19.9995 18.7752 19.8237 19.1988 19.5113 19.5113C19.1988 19.8237 18.7752 19.9995 18.3333 20ZM1.66667 0.666667C1.40145 0.666667 1.1471 0.772024 0.95956 0.95956C0.772024 1.1471 0.666667 1.40145 0.666667 1.66667V18.3333C0.666667 18.5986 0.772024 18.8529 0.95956 19.0404C1.1471 19.228 1.40145 19.3333 1.66667 19.3333H18.3333C18.5986 19.3333 18.8529 19.228 19.0404 19.0404C19.228 18.8529 19.3333 18.5986 19.3333 18.3333V1.66667C19.3333 1.40145 19.228 1.1471 19.0404 0.95956C18.8529 0.772024 18.5986 0.666667 18.3333 0.666667H1.66667Z" fill="#1E81CE"/>
                  <path d="M10.0002 7.33333C9.67053 7.33333 9.34829 7.23558 9.07421 7.05245C8.80013 6.86931 8.58651 6.60902 8.46036 6.30447C8.33422 5.99993 8.30121 5.66482 8.36552 5.34152C8.42983 5.01821 8.58856 4.72124 8.82165 4.48816C9.05474 4.25507 9.35171 4.09633 9.67501 4.03203C9.99831 3.96772 10.3334 4.00072 10.638 4.12687C10.9425 4.25301 11.2028 4.46663 11.3859 4.74072C11.5691 5.0148 11.6668 5.33703 11.6668 5.66667C11.6663 6.10853 11.4905 6.53215 11.1781 6.84459C10.8656 7.15704 10.442 7.3328 10.0002 7.33333V7.33333ZM10.0002 4.66667C9.80238 4.66667 9.60904 4.72532 9.44459 4.8352C9.28014 4.94508 9.15197 5.10126 9.07628 5.28398C9.0006 5.46671 8.98079 5.66778 9.01938 5.86176C9.05796 6.05574 9.1532 6.23392 9.29306 6.37377C9.43291 6.51363 9.61109 6.60887 9.80507 6.64745C9.99905 6.68604 10.2001 6.66623 10.3828 6.59055C10.5656 6.51486 10.7217 6.38668 10.8316 6.22224C10.9415 6.05779 11.0002 5.86445 11.0002 5.66667C11.0002 5.40145 10.8948 5.1471 10.7073 4.95956C10.5197 4.77202 10.2654 4.66667 10.0002 4.66667V4.66667Z" fill="#1E81CE"/>
                  <path d="M11.3335 16.6667H8.66683C8.57842 16.6667 8.49364 16.6315 8.43113 16.569C8.36861 16.5065 8.3335 16.4217 8.3335 16.3333V8.33333C8.3335 8.24493 8.36861 8.16014 8.43113 8.09763C8.49364 8.03512 8.57842 8 8.66683 8H11.3335C11.4219 8 11.5067 8.03512 11.5692 8.09763C11.6317 8.16014 11.6668 8.24493 11.6668 8.33333V16.3333C11.6668 16.4217 11.6317 16.5065 11.5692 16.569C11.5067 16.6315 11.4219 16.6667 11.3335 16.6667ZM9.00016 16H11.0002V8.66667H9.00016V16Z" fill="#1E81CE"/>
                </svg>

                {{ I18n.t("sport_events.show.event_participation_request_description") }}

                <div style="margin-top: 12px;">
                  <button v-on:click.prevent.stop="participationRequest()" class="btn cta-btn purple">
                    {{ I18n.t("sport_events.show.event_participation_request_button") }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="isUserCanParticipate && !is_creator_know_current_user" class="participation-request-wrap">
              <div>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.3335 0.333374H1.66683C1.31321 0.333374 0.974069 0.47385 0.72402 0.723898C0.473972 0.973947 0.333496 1.31309 0.333496 1.66671V18.3334C0.333496 18.687 0.473972 19.0261 0.72402 19.2762C0.974069 19.5262 1.31321 19.6667 1.66683 19.6667H18.3335C18.6871 19.6667 19.0263 19.5262 19.2763 19.2762C19.5264 19.0261 19.6668 18.687 19.6668 18.3334V1.66671C19.6668 1.31309 19.5264 0.973947 19.2763 0.723898C19.0263 0.47385 18.6871 0.333374 18.3335 0.333374ZM11.3335 16.3334H8.66683V8.33337H11.3335V16.3334ZM10.0002 7.00004C9.73645 7.00004 9.47867 6.92184 9.2594 6.77533C9.04014 6.62882 8.86924 6.42059 8.76832 6.17695C8.66741 5.93332 8.641 5.66523 8.69245 5.40659C8.7439 5.14795 8.87088 4.91037 9.05735 4.7239C9.24382 4.53743 9.4814 4.41044 9.74004 4.35899C9.99868 4.30755 10.2668 4.33395 10.5104 4.43487C10.754 4.53578 10.9623 4.70668 11.1088 4.92595C11.2553 5.14521 11.3335 5.403 11.3335 5.66671C11.3335 6.02033 11.193 6.35947 10.943 6.60952C10.6929 6.85956 10.3538 7.00004 10.0002 7.00004V7.00004Z" fill="#9BC9FF"/>
                  <path d="M18.3333 20H1.66667C1.2248 19.9995 0.801186 19.8237 0.48874 19.5113C0.176294 19.1988 0.000529286 18.7752 0 18.3333V1.66667C0.000529286 1.2248 0.176294 0.801186 0.48874 0.48874C0.801186 0.176294 1.2248 0.000529286 1.66667 0H18.3333C18.7752 0.000529286 19.1988 0.176294 19.5113 0.48874C19.8237 0.801186 19.9995 1.2248 20 1.66667V18.3333C19.9995 18.7752 19.8237 19.1988 19.5113 19.5113C19.1988 19.8237 18.7752 19.9995 18.3333 20ZM1.66667 0.666667C1.40145 0.666667 1.1471 0.772024 0.95956 0.95956C0.772024 1.1471 0.666667 1.40145 0.666667 1.66667V18.3333C0.666667 18.5986 0.772024 18.8529 0.95956 19.0404C1.1471 19.228 1.40145 19.3333 1.66667 19.3333H18.3333C18.5986 19.3333 18.8529 19.228 19.0404 19.0404C19.228 18.8529 19.3333 18.5986 19.3333 18.3333V1.66667C19.3333 1.40145 19.228 1.1471 19.0404 0.95956C18.8529 0.772024 18.5986 0.666667 18.3333 0.666667H1.66667Z" fill="#1E81CE"/>
                  <path d="M10.0002 7.33333C9.67053 7.33333 9.34829 7.23558 9.07421 7.05245C8.80013 6.86931 8.58651 6.60902 8.46036 6.30447C8.33422 5.99993 8.30121 5.66482 8.36552 5.34152C8.42983 5.01821 8.58856 4.72124 8.82165 4.48816C9.05474 4.25507 9.35171 4.09633 9.67501 4.03203C9.99831 3.96772 10.3334 4.00072 10.638 4.12687C10.9425 4.25301 11.2028 4.46663 11.3859 4.74072C11.5691 5.0148 11.6668 5.33703 11.6668 5.66667C11.6663 6.10853 11.4905 6.53215 11.1781 6.84459C10.8656 7.15704 10.442 7.3328 10.0002 7.33333V7.33333ZM10.0002 4.66667C9.80238 4.66667 9.60904 4.72532 9.44459 4.8352C9.28014 4.94508 9.15197 5.10126 9.07628 5.28398C9.0006 5.46671 8.98079 5.66778 9.01938 5.86176C9.05796 6.05574 9.1532 6.23392 9.29306 6.37377C9.43291 6.51363 9.61109 6.60887 9.80507 6.64745C9.99905 6.68604 10.2001 6.66623 10.3828 6.59055C10.5656 6.51486 10.7217 6.38668 10.8316 6.22224C10.9415 6.05779 11.0002 5.86445 11.0002 5.66667C11.0002 5.40145 10.8948 5.1471 10.7073 4.95956C10.5197 4.77202 10.2654 4.66667 10.0002 4.66667V4.66667Z" fill="#1E81CE"/>
                  <path d="M11.3335 16.6667H8.66683C8.57842 16.6667 8.49364 16.6315 8.43113 16.569C8.36861 16.5065 8.3335 16.4217 8.3335 16.3333V8.33333C8.3335 8.24493 8.36861 8.16014 8.43113 8.09763C8.49364 8.03512 8.57842 8 8.66683 8H11.3335C11.4219 8 11.5067 8.03512 11.5692 8.09763C11.6317 8.16014 11.6668 8.24493 11.6668 8.33333V16.3333C11.6668 16.4217 11.6317 16.5065 11.5692 16.569C11.5067 16.6315 11.4219 16.6667 11.3335 16.6667ZM9.00016 16H11.0002V8.66667H9.00016V16Z" fill="#1E81CE"/>
                </svg>

                {{ I18n.t("sport_events.show.event_participation_request_description") }}

                <div style="margin-top: 12px;">
                  <button v-on:click.prevent.stop="openParticipationWithCommentModal()" class="btn cta-btn purple">
                    {{ I18n.t("sport_events.show.event_participation_request_button") }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="this.user.is_guest" class="sport-event__actions--guest">
              <font-awesome-icon icon="exclamation-circle" size="lg" />
              <a href="/users/sign_in">{{ I18n.t("sport_events.guest_user_message.sign_in") }}</a>
              {{ I18n.t("sport_events.guest_user_message.or") }}
              <a href="/users/sign_up">{{ I18n.t("sport_events.guest_user_message.register") }}</a>,
              {{ I18n.t("sport_events.guest_user_message.reason") }}
            </div>
            <div v-if="isUserRequestParticipation && isWaitingForParticipants" class="sport-event__actions--requested-participant">
              <div style="display: flex; align-items: center;">
                <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M25.5209 0H9.47925C8.27113 0 7.29175 0.979385 7.29175 2.1875C7.29175 3.39562 8.27113 4.375 9.47925 4.375H25.5209C26.7291 4.375 27.7084 3.39562 27.7084 2.1875C27.7084 0.979385 26.729 0 25.5209 0Z" fill="#455A64"/>
                  <path d="M25.5208 32.0833H9.47919C9.07648 32.0833 8.75 31.7568 8.75 31.3541V25.251C8.74993 23.3583 9.56696 21.5578 10.9914 20.3116L13.5771 18.0483C13.8799 17.7829 13.9102 17.3222 13.6447 17.0194C13.6237 16.9954 13.6011 16.9727 13.5771 16.9517L10.9914 14.6884C9.56696 13.4422 8.74993 11.6417 8.75 9.749V3.64588C8.75 3.24317 9.07648 2.91669 9.47919 2.91669H25.5209C25.9236 2.91669 26.2501 3.24317 26.2501 3.64588V9.749C26.2501 11.6417 25.4331 13.4422 24.0086 14.6884L21.423 16.9517C21.1202 17.2171 21.0899 17.6778 21.3553 17.9806C21.3764 18.0046 21.399 18.0273 21.423 18.0483L24.0086 20.3116C25.4331 21.5578 26.2501 23.3583 26.2501 25.251V31.3541C26.25 31.7569 25.9235 32.0833 25.5208 32.0833Z" fill="#455A64"/>
                  <path d="M10.2083 30.625H24.7916V25.2511C24.7898 23.7781 24.1518 22.3777 23.0416 21.4098L20.4559 19.1465C19.5466 18.3511 19.4543 16.9691 20.2498 16.0598C20.3138 15.9866 20.3827 15.9177 20.4559 15.8536L23.0416 13.5903C24.1518 12.6224 24.7898 11.222 24.7916 9.74907V4.375H10.2083V9.74894C10.21 11.2219 10.848 12.6223 11.9583 13.5902L14.5439 15.8535C15.4528 16.6494 15.5444 18.0314 14.7485 18.9403C14.6849 19.013 14.6165 19.0814 14.5439 19.145L11.9583 21.4098C10.848 22.3777 10.21 23.7781 10.2083 25.2511V30.625Z" fill="#ECEFF1"/>
                  <path d="M21.8196 12.1173C21.7069 11.8446 21.441 11.6668 21.1459 11.6667H13.8543C13.4516 11.6659 13.1245 11.9919 13.1238 12.3946C13.1234 12.5887 13.2005 12.775 13.338 12.9121L16.9838 16.5579C17.2685 16.8426 17.7301 16.8426 18.0149 16.5579L21.6607 12.9121C21.8696 12.7037 21.9324 12.39 21.8196 12.1173Z" fill="#FFC107"/>
                  <path d="M25.5209 30.625H9.47925C8.27113 30.625 7.29175 31.6044 7.29175 32.8125C7.29175 34.0206 8.27113 35 9.47925 35H25.5209C26.7291 35 27.7084 34.0206 27.7084 32.8125C27.7084 31.6044 26.729 30.625 25.5209 30.625Z" fill="#455A64"/>
                  <path d="M17.9899 22.7938C17.7019 22.533 17.26 22.5439 16.9851 22.8186L10.2083 29.594V30.625H24.7916V28.9771L17.9899 22.7938Z" fill="#FFC107"/>
                </svg>

                <div>{{ I18n.t("sport_events.show.requested_participation_message") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="status-wrap">
        <step-progress :steps="translatedStatuses" :current-step="currentStatusStep" :lastItemFailed="this.sportEvent.status == 'canceled'"></step-progress>
      </div>

      <div v-if="isShowChat" class="sport-event__chat-link">
        <a :href="chatLinkHref()" v-if="!this.sportEvent.latest_chat_message || Object.keys(this.sportEvent.latest_chat_message).length == 0" style="text-decoration: none;">
          <div class="sport-event__chat-link-empty-box" >
            <div class="sport_event__chat-empty-text">
              <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                <path d="M49.9908 15.2983C47.7638 9.63167 40.9038 6.2335 35.0936 8.48228C28.4614 11.0491 30.6604 21.5981 24.6363 23.7313C21.3822 24.8836 16.5717 20.5792 13.284 19.9192C7.22561 18.703 1.74112 22.9777 0.390618 28.8974C-0.987179 34.9367 1.22265 43.0031 7.85803 44.6423C15.762 46.5948 19.8792 39.4896 26.5098 37.4494C33.3141 35.3557 40.8797 40.3004 46.5127 34.2842C50.6744 29.8395 52.196 20.9094 49.9908 15.2983V15.2983Z" fill="url(#paint0_linear)"/>
                <path opacity="0.1" d="M47.4985 17.7895C47.4985 13.8552 44.3091 10.6658 40.3747 10.6658C37.3267 10.6658 34.727 12.5808 33.7099 15.2727H7.9502C6.84991 15.2727 5.95801 16.1646 5.95801 17.2649V39.3194C5.95801 40.4197 6.84991 41.3116 7.9502 41.3116H43.05C44.1503 41.3116 45.0422 40.4197 45.0422 39.3194V23.1687C46.5461 21.8626 47.4985 19.9379 47.4985 17.7895V17.7895Z" fill="#2626BC"/>
                <path d="M43.0497 38.8214H7.94971C6.84942 38.8214 5.95752 37.9295 5.95752 36.8292V14.7747C5.95752 13.6744 6.84942 12.7825 7.94971 12.7825H43.0496C44.1498 12.7825 45.0417 13.6744 45.0417 14.7747V36.8292C45.0418 37.9295 44.1498 38.8214 43.0497 38.8214Z" fill="#9FB0FE"/>
                <path d="M45.0422 14.7751V23.1921C43.7921 24.2769 42.1605 24.9343 40.3746 24.9343C36.44 24.9343 33.2505 21.7448 33.2505 17.8112C33.2505 15.8489 34.0444 14.0709 35.3283 12.783H43.0501C44.1497 12.783 45.0422 13.6745 45.0422 14.7751Z" fill="#8399FE"/>
                <path d="M45.0422 14.7751V17.2863L27.3207 30.8999C26.8008 31.2993 26.1543 31.5185 25.4999 31.5185C24.8454 31.5185 24.199 31.2993 23.679 30.8999L5.95752 17.2863V14.7751C5.95752 13.6745 6.85002 12.783 7.94971 12.783H43.0501C44.1497 12.783 45.0422 13.6745 45.0422 14.7751V14.7751Z" fill="#8399FE"/>
                <path d="M26.1065 22.2837L45.0418 36.8292C45.0418 37.9294 44.1499 38.8214 43.0497 38.8214H7.94971C6.84942 38.8214 5.95752 37.9294 5.95752 36.8292L24.8929 22.2837C25.2508 22.0088 25.7486 22.0088 26.1065 22.2837V22.2837Z" fill="#8399FE"/>
                <path d="M32.3217 27.058L27.3204 30.8999C26.8004 31.2994 26.1539 31.5185 25.4995 31.5185C24.8451 31.5185 24.1986 31.2994 23.6786 30.8999L18.6772 27.058L24.8929 22.2837C25.2505 22.0088 25.7485 22.0088 26.1061 22.2837L32.3217 27.058Z" fill="#6583FE"/>
                <path d="M24.8929 29.3202L5.95752 14.7747C5.95752 13.6744 6.84942 12.7825 7.94971 12.7825H43.0496C44.1498 12.7825 45.0417 13.6744 45.0417 14.7747L26.1065 29.3202C25.7486 29.5951 25.2508 29.5951 24.8929 29.3202Z" fill="#B7C5FF"/>
                <path d="M36.9504 36.1706H33.7495C33.4745 36.1706 33.2515 35.9476 33.2515 35.6726V33.4658C33.2515 33.1908 33.4745 32.9678 33.7495 32.9678H36.9504C37.2254 32.9678 37.4484 33.1908 37.4484 33.4658V35.6726C37.4484 35.9477 37.2254 36.1706 36.9504 36.1706Z" fill="#02FFB3"/>
                <path d="M31.0654 34.1404H28.293C28.0178 34.1404 27.7949 33.9174 27.7949 33.6423C27.7949 33.3673 28.0178 33.1443 28.293 33.1443H31.0654C31.3405 33.1443 31.5634 33.3673 31.5634 33.6423C31.5634 33.9174 31.3405 34.1404 31.0654 34.1404Z" fill="white"/>
                <path d="M31.0654 36.1707H21.3203C21.0452 36.1707 20.8223 35.9476 20.8223 35.6726C20.8223 35.3976 21.0452 35.1746 21.3203 35.1746H31.0654C31.3405 35.1746 31.5634 35.3976 31.5634 35.6726C31.5634 35.9476 31.3405 36.1707 31.0654 36.1707Z" fill="white"/>
                <path d="M40.3747 22.4231C44.3091 22.4231 47.4985 19.2336 47.4985 15.2993C47.4985 11.365 44.3091 8.17554 40.3747 8.17554C36.4404 8.17554 33.251 11.365 33.251 15.2993C33.251 19.2336 36.4404 22.4231 40.3747 22.4231Z" fill="#FF5BA8"/>
                <path d="M40.3747 22.9211C44.5774 22.9211 47.9965 19.502 47.9965 15.2993C47.9965 11.0966 44.5775 7.67749 40.3747 7.67749C36.172 7.67749 32.7529 11.0966 32.7529 15.2993C32.7529 17.7441 33.9113 19.9222 35.7066 21.3178L25.8035 28.9252C25.6251 29.0624 25.3755 29.0625 25.1967 28.9252L6.47388 14.543C6.58555 13.8288 7.20512 13.2805 7.9501 13.2805H30.7971C31.0722 13.2805 31.2951 13.0575 31.2951 12.7825C31.2951 12.5074 31.0722 12.2844 30.7971 12.2844H7.9502C6.57708 12.2844 5.45996 13.4015 5.45996 14.7747V36.8292C5.45996 38.2023 6.57708 39.3194 7.9502 39.3194H43.05C44.4232 39.3194 45.5403 38.2023 45.5403 36.8292V23.6668C45.5403 23.3918 45.3174 23.1687 45.0422 23.1687C44.7671 23.1687 44.5442 23.3918 44.5442 23.6668V35.8185L31.5045 25.8019L36.5786 21.9042C37.6972 22.5497 38.9931 22.9211 40.3747 22.9211V22.9211ZM19.4956 25.8019L6.45605 35.8185V15.7853L19.4956 25.8019ZM44.5245 37.0596C44.4131 37.7742 43.7953 38.3233 43.0499 38.3233H7.9502C7.20482 38.3233 6.58704 37.7742 6.47568 37.0596L20.3133 26.43L24.5899 29.7151C24.8579 29.9209 25.179 30.0239 25.5002 30.0239C25.8213 30.0239 26.1424 29.921 26.4104 29.7151L30.687 26.4299L44.5245 37.0596ZM33.749 15.2993C33.749 11.6459 36.7213 8.67358 40.3747 8.67358C44.0282 8.67358 47.0005 11.6458 47.0005 15.2993C47.0005 18.9528 44.0282 21.925 40.3747 21.925C36.7213 21.925 33.749 18.9527 33.749 15.2993Z" fill="#2626BC"/>
                <path d="M37.2651 12.87L38.2818 15.2994L37.2651 17.7287C37.0925 18.1413 37.509 18.5547 37.9202 18.379L44.058 15.7574C44.4612 15.5851 44.4612 15.0136 44.058 14.8414L37.9202 12.2197C37.509 12.044 37.0925 12.4574 37.2651 12.87V12.87Z" fill="white"/>
                <path d="M40.6009 15.7643L37.5404 17.0722L38.2817 15.2992L37.5396 13.5261L40.6009 14.834C40.9827 14.9974 40.9827 15.602 40.6009 15.7643V15.7643Z" fill="#FFDBED"/>
                <path d="M32.9535 8.13518C32.5835 8.13518 32.2137 7.99443 31.9322 7.71283C31.369 7.14964 31.369 6.23334 31.9322 5.67024C32.4951 5.10725 33.4116 5.10705 33.9747 5.67024C34.5378 6.23344 34.5378 7.14974 33.9747 7.71283C33.6932 7.99443 33.3233 8.13518 32.9535 8.13518ZM32.9535 6.2435C32.8387 6.2435 32.7239 6.28712 32.6364 6.37458C32.4617 6.5493 32.4617 6.83368 32.6364 7.0085C32.8113 7.18321 33.0954 7.18331 33.2703 7.0085C33.445 6.83378 33.445 6.5494 33.2703 6.37458C33.183 6.28722 33.0681 6.2435 32.9535 6.2435V6.2435Z" fill="#00ECA2"/>
                <path d="M21.7684 45.752C21.3985 45.752 21.0286 45.6112 20.7471 45.3297C20.1839 44.7665 20.1839 43.8502 20.7471 43.2871C21.3101 42.724 22.2267 42.724 22.7897 43.2871C23.3529 43.8503 23.3529 44.7666 22.7897 45.3297C22.5082 45.6113 22.1382 45.752 21.7684 45.752V45.752ZM21.7684 43.8603C21.6536 43.8603 21.5388 43.9039 21.4513 43.9914C21.2766 44.1661 21.2766 44.4505 21.4513 44.6253C21.6263 44.8001 21.9104 44.8001 22.0854 44.6253C22.2601 44.4506 22.2601 44.1662 22.0854 43.9914C21.998 43.904 21.8831 43.8603 21.7684 43.8603V43.8603Z" fill="#00ECA2"/>
                <path d="M29.3628 9.41775C29.2354 9.41775 29.1078 9.36914 29.0106 9.27192L28.4165 8.67785L27.8223 9.27192C27.628 9.46636 27.3124 9.46636 27.1181 9.27192C26.9235 9.07738 26.9235 8.76202 27.1181 8.56758L28.0644 7.62129C28.2587 7.42685 28.5743 7.42685 28.7686 7.62129L29.7149 8.56758C29.9094 8.76212 29.9094 9.07748 29.7149 9.27192C29.6178 9.36904 29.4903 9.41775 29.3628 9.41775Z" fill="#FF7EB8"/>
                <path d="M43.8032 43.8603C43.6758 43.8603 43.5482 43.8116 43.4511 43.7144L42.8569 43.1204L42.2627 43.7144C42.0684 43.9089 41.7528 43.9089 41.5585 43.7144C41.364 43.5199 41.364 43.2045 41.5585 43.0101L42.5048 42.0638C42.6991 41.8694 43.0147 41.8694 43.209 42.0638L44.1553 43.0101C44.3499 43.2046 44.3499 43.52 44.1553 43.7144C44.0582 43.8115 43.9306 43.8603 43.8032 43.8603Z" fill="#FF7EB8"/>
                <path d="M17.8183 44.3334C17.6909 44.3334 17.5633 44.2848 17.4662 44.1876L16.872 43.5935L16.2779 44.1876C16.0835 44.382 15.768 44.382 15.5736 44.1876C15.3791 43.993 15.3791 43.6777 15.5736 43.4832L16.5199 42.5369C16.7143 42.3425 17.0298 42.3425 17.2242 42.5369L18.1705 43.4832C18.365 43.6778 18.365 43.9931 18.1705 44.1876C18.0732 44.2847 17.9457 44.3334 17.8183 44.3334Z" fill="#6583FE"/>
                </g>
                <defs>
                <linearGradient id="paint0_linear" x1="43.0641" y1="50.0681" x2="19.7555" y2="19.1892" gradientUnits="userSpaceOnUse">
                <stop stop-color="#C6D1FF"/>
                <stop offset="0.5834" stop-color="#E6D5F4"/>
                <stop offset="0.997" stop-color="#FFD9EC"/>
                </linearGradient>
                <clipPath id="clip0">
                <rect width="51" height="51" fill="white"/>
                </clipPath>
                </defs>
              </svg>

              <div style="font-weight: 400;">{{ I18n.t("sport_events.show.empty_message_list") }}</div>
            </div>

            <a :href="chatLinkHref()" v-if="$mq == 'sm'" class="cta purple mobile-chat-link" style="font-weight: 400;">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2637 3.23938C19.9459 2.55359 19.9444 1.44514 19.2604 0.761189L19.1323 0.64501C18.4451 0.0808307 17.4286 0.121295 16.7889 0.764507L8.32075 9.27821C7.56279 10.0403 7.02344 10.9919 6.75908 12.0337L6.40926 13.4123L6.41641 13.4655C6.43969 13.5502 6.51721 13.6123 6.60926 13.6123L7.94842 13.3049C9.05209 13.0516 10.0615 12.4911 10.8601 11.6883L19.2637 3.23938ZM9.25 3.56449C9.25 3.15028 8.91421 2.81449 8.5 2.81449H4L3.81558 2.81963C2.10645 2.91524 0.75 4.33146 0.75 6.06449V16.0645L0.755145 16.2489C0.850754 17.958 2.26697 19.3145 4 19.3145H14L14.1844 19.3093C15.8935 19.2137 17.25 17.7975 17.25 16.0645L17.2445 11.5636C17.244 11.1497 16.9083 10.8145 16.4945 10.8145H15.5C15.0858 10.8145 14.75 11.1503 14.75 11.5645V16.0645L14.7432 16.1663C14.6935 16.5323 14.3797 16.8145 14 16.8145H4L3.89823 16.8076C3.53215 16.758 3.25 16.4442 3.25 16.0645V6.06449L3.25685 5.96272C3.30651 5.59664 3.6203 5.31449 4 5.31449L8.50092 5.30896C8.91477 5.30845 9.25 4.97281 9.25 4.55896V3.56449Z" fill="white"/>
              </svg>
            </a>

            <a :href="chatLinkHref()" v-else class="cta cta-btn purple lg-chat-link">
              <font-awesome-icon icon="plus" />
              {{ I18n.t("sport_events.show.write_message_link") }}
            </a>
          </div>
        </a>

        <div class="sport-event__chat-link-box" v-else>
          <a :href="chatLinkHref()" style="display: flex; justify-content: space-between; text-decoration: none;">
            <div style="display: flex;">
              <div class="author-avatar">
                <img :src="avatarPath(this.sportEvent.latest_chat_message.full_author)" style="border-radius: 50px; width: 50px; height: 50px;" loading="lazy">
              </div>
              <div style="margin-left: 24px; display: flex; flex-direction: column; justify-content: space-around;">
                <div style="font-size: 16px;">
                  {{ this.sportEvent.latest_chat_message.author_nickname.substring(0,16) }}
                </div>

                <div style="font-size: 13px; color: #979797; font-weight: 400;">
                  {{ this.sportEvent.latest_chat_message.body }}
                </div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column; justify-content: space-around; align-items: flex-end;">
              <div style="font-size: 11px; font-weight: 400; color: rgb(151, 151, 151);">
                {{ this.sportEvent.latest_chat_message.time_ago }}
              </div>
              <div class="unread-messages" v-if="this.unread_chat_messages_count > 0">
                {{ this.unread_chat_messages_count }}
              </div>

              <div style="height: 20px;" v-else>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="participation-requests" v-if="isUserCreator() && requestsFromParticipants.length > 0">
        <a :href="`/sport_events/${this.sportEvent.id}/partners`" class="btn cta-btn purple">
          {{ I18n.t("sport_events.show.participation_requests", { count: requestsFromParticipants.length }) }}
        </a>
      </div>

      <div class="paricipants">
        <div class="creator-info">
          <div class=creator-info__avatar>
            <a :href="`/users/${this.creator.nickname}`">
              <img :src="avatarPath(this.creator, 50)" style="border-radius: 50px; width: 50px; height: 50px;" loading="lazy">
            </a>
          </div>

          <div style="display: flex; justify-content: space-between;width: 100%;">
            <div style="margin-left: 12px;">
              <div style="font-weight: 450; font-size: 14px;">{{ this.creator.full_name }}</div>
              <div style="margin-top: 6px;">{{ this.creator.nickname }}</div>
              <div style="margin-top: 6px; color: grey">{{ I18n.t("sport_events.show.event_creator") }}</div>
            </div>
            <div style="font-size: 12px; color: grey">{{ I18n.t("sport_events.show.events_count") }} {{ this.creator.successful_events_as_creator }}</div>
          </div>
        </div>

        <div style="display: flex; justify-content: space-between;">
          <div class="accepted-participants">
            <div style="font-weight: 450; font-size: 14px; display: flex;">
              {{ I18n.t("sport_events.show.participants_title") }}
              <div style="margin-left: 6px; padding-bottom: 2px;" :class="acceptedParticipantsTitleClass(acceptedParticipants.length, sportEvent.minimal_participants_count)">
                {{ acceptedParticipants.length }} / {{ sportEvent.minimal_participants_count }}
              </div>
            </div>
            <div style="margin-top: 12px; display: flex;">
              <div v-for="participant in acceptedParticipants" style="margin-right: 6px;">
                <a :href="`/users/${participant.nickname}`">
                  <img :src="avatarPath(participant, 30)" style="border-radius: 30px; width: 30px; height: 30px;" loading="lazy">
                </a>

              </div>
            </div>
          </div>
          <div v-if="isUserAlreadyParticipant" class="sport-event__actions--accepted-participant">
            <div style="display: flex; justify-content: center; align-items: center; color: #0b6135; font-weight: 450; font-size: 12px; text-transform: lowercase;">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.49993 0.46875C6.2236 0.46863 4.97131 0.81592 3.87735 1.47338C2.78339 2.13084 1.88901 3.07366 1.29012 4.20076C0.691239 5.32786 0.410436 6.59671 0.477827 7.87126C0.545219 9.1458 0.958261 10.378 1.67266 11.4356L0.468679 14.5313L3.5643 13.3273C4.4754 13.9425 5.51805 14.3354 6.60854 14.4746C7.69903 14.6139 8.80696 14.4954 9.84339 14.1289C10.8798 13.7623 11.8159 13.1579 12.5763 12.364C13.3368 11.5702 13.9006 10.609 14.2223 9.55783C14.5441 8.50663 14.6148 7.39463 14.429 6.31112C14.2431 5.22761 13.8057 4.20278 13.152 3.31893C12.4983 2.43507 11.6464 1.71681 10.6648 1.22182C9.68325 0.726829 8.59927 0.468903 7.49993 0.46875V0.46875Z" fill="#559B2D"/>
                <path d="M7.5 12.6562C10.3477 12.6562 12.6562 10.3477 12.6562 7.5C12.6562 4.65228 10.3477 2.34375 7.5 2.34375C4.65228 2.34375 2.34375 4.65228 2.34375 7.5C2.34375 10.3477 4.65228 12.6562 7.5 12.6562Z" fill="#F2F2F2"/>
                <path d="M11.4845 6.79687C11.485 6.02121 11.3102 5.25547 10.9731 4.5569C10.636 3.85833 10.1453 3.24501 9.53774 2.7628C8.39037 2.26988 7.10309 2.21011 5.91498 2.59457C4.72686 2.97904 3.71864 3.78162 3.07755 4.85327C2.43645 5.92493 2.20606 7.19283 2.42915 8.42151C2.65224 9.6502 3.31365 10.7562 4.29056 11.5341C5.07499 11.8712 5.93086 12.0083 6.78135 11.9331C7.63185 11.8579 8.45037 11.5727 9.16346 11.1031C9.87656 10.6336 10.4619 9.99429 10.867 9.24269C11.2721 8.49109 11.4843 7.65068 11.4845 6.79687V6.79687Z" fill="white"/>
                <path d="M3.98438 8.67188L5.85938 10.5469L11.0156 5.39062L10.0781 4.45312L5.85938 8.67188L4.92188 7.73438L3.98438 8.67188Z" fill="#559B2D"/>
                <path d="M7.50002 0.234375C6.19161 0.23424 4.90745 0.587424 3.78313 1.25663C2.65882 1.92584 1.73608 2.88623 1.11235 4.0364C0.488615 5.18657 0.187045 6.48382 0.239481 7.79118C0.291916 9.09853 0.696411 10.3675 1.41025 11.464L0.250329 14.4464C0.236538 14.4819 0.231612 14.5203 0.235978 14.5581C0.240343 14.596 0.253869 14.6322 0.275384 14.6636C0.296899 14.6951 0.325754 14.7208 0.359451 14.7386C0.393147 14.7563 0.430669 14.7656 0.468767 14.7656C0.497797 14.7657 0.526577 14.7603 0.553611 14.7497L3.53603 13.5898C4.48379 14.2065 5.56242 14.5935 6.68608 14.72C7.80974 14.8465 8.94742 14.709 10.0086 14.3184C11.0697 13.9278 12.0251 13.2949 12.7986 12.4701C13.5721 11.6453 14.1424 10.6514 14.4642 9.56736C14.7859 8.48334 14.8502 7.33918 14.6519 6.22594C14.4536 5.11271 13.9982 4.06111 13.322 3.15485C12.6458 2.24859 11.7673 1.51267 10.7566 1.00566C9.74589 0.498655 8.63078 0.234554 7.50002 0.234375V0.234375ZM7.50002 14.2969C6.14398 14.2992 4.81856 13.8938 3.69588 13.1332C3.65702 13.107 3.61125 13.093 3.56439 13.0929C3.53535 13.0929 3.50657 13.0984 3.47955 13.1091L0.880329 14.1197L1.89095 11.5205C1.90483 11.4852 1.90994 11.4471 1.90586 11.4094C1.90178 11.3717 1.88862 11.3356 1.86752 11.3041C1.01862 10.0472 0.614528 8.5425 0.719538 7.02942C0.824548 5.51634 1.43263 4.08185 2.44701 2.95426C3.46139 1.82666 4.82378 1.07075 6.31736 0.806822C7.81094 0.542894 9.34989 0.786116 10.6893 1.49778C12.0287 2.20944 13.0916 3.34866 13.7088 4.73412C14.326 6.11958 14.462 7.67167 14.0953 9.14339C13.7286 10.6151 12.8801 11.9219 11.685 12.8557C10.4899 13.7896 9.01674 14.2969 7.50002 14.2969V14.2969Z" fill="black"/>
                <path d="M7.5 2.10938C6.43384 2.10938 5.39162 2.42553 4.50513 3.01786C3.61865 3.61019 2.92772 4.45209 2.51971 5.4371C2.11171 6.42211 2.00496 7.50598 2.21296 8.55166C2.42096 9.59734 2.93436 10.5579 3.68825 11.3117C4.44215 12.0656 5.40266 12.579 6.44834 12.787C7.49402 12.995 8.5779 12.8883 9.56291 12.4803C10.5479 12.0723 11.3898 11.3814 11.9821 10.4949C12.5745 9.60839 12.8906 8.56617 12.8906 7.5C12.889 6.07081 12.3206 4.70062 11.31 3.69003C10.2994 2.67945 8.92919 2.11099 7.5 2.10938V2.10938ZM7.5 12.4219C6.52655 12.4219 5.57495 12.1332 4.76556 11.5924C3.95616 11.0516 3.32531 10.2829 2.95278 9.38352C2.58026 8.48417 2.48279 7.49454 2.6727 6.53979C2.86261 5.58504 3.33137 4.70805 4.01971 4.01971C4.70805 3.33137 5.58504 2.86261 6.53979 2.6727C7.49454 2.48279 8.48417 2.58026 9.38352 2.95278C10.2829 3.32531 11.0516 3.95615 11.5924 4.76555C12.1332 5.57495 12.4219 6.52655 12.4219 7.5C12.4204 8.80491 11.9014 10.0559 10.9786 10.9786C10.0559 11.9014 8.80491 12.4204 7.5 12.4219Z" fill="black"/>
                <path d="M11.1813 5.22493L10.2438 4.28743C10.1998 4.24349 10.1402 4.21881 10.0781 4.21881C10.0159 4.21881 9.95632 4.24349 9.91237 4.28743L5.85932 8.34048L5.08753 7.56868C5.04358 7.52474 4.98397 7.50006 4.92182 7.50006C4.85968 7.50006 4.80007 7.52474 4.75612 7.56868L3.81862 8.50618C3.77468 8.55013 3.75 8.60974 3.75 8.67189C3.75 8.73403 3.77468 8.79364 3.81862 8.83759L5.69362 10.7126C5.73757 10.7565 5.79718 10.7812 5.85932 10.7812C5.92147 10.7812 5.98108 10.7565 6.02503 10.7126L11.1813 5.55634C11.2252 5.51239 11.2499 5.45278 11.2499 5.39064C11.2499 5.32849 11.2252 5.26888 11.1813 5.22493V5.22493ZM5.85932 10.2155L4.31573 8.67189L4.92182 8.06579L5.69362 8.83759C5.73757 8.88153 5.79718 8.90621 5.85932 8.90621C5.92147 8.90621 5.98108 8.88153 6.02503 8.83759L10.0781 4.78454L10.6842 5.39064L5.85932 10.2155Z" fill="black"/>
              </svg>

              {{ I18n.t("sport_events.show.participant_message") }}
            </div>

            <div v-if="['waiting', 'ready'].includes(this.sportEvent.status) && !isUserCreator()" style="margin: 6px;" class="reject-participation">
              <a style="font-weight: 400;" v-on:click.prevent.stop="openRejectParticipationModal()" class="text-danger">
                {{ I18n.t("sport_events.show.participation_reject_button") }}
              </a>
            </div>
          </div>
        </div>
        <div class="waiting-approve" style="margin-top: 18px;" v-if="isUserCreator() && requestsFromCreator.length > 0">
          <div style="font-weight: 450; font-size: 14px;">
            {{ I18n.t("sport_events.show.waiting_title") }}
          </div>

          <div style="margin-top: 12px; display: flex;">
            <div v-for="participant in requestsFromCreator" style="margin-right: 6px;">
              <a :href="`/users/${participant.id}`">
                <img :src="avatarPath(participant, 30)" style="border-radius: 30px; width: 30px; height: 30px;" loading="lazy">
              </a>
            </div>
          </div>
        </div>

        <div style="margin-top: 18px;">
          <a :href="`/sport_events/${this.sportEvent.id}/partners`" class="light-link">
            {{ I18n.t("sport_event.show_link") }}
            <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 3px;">
              <path d="M1 1L6 6L1 10.5" stroke="#5D98AE"/>
            </svg>
          </a>
        </div>
      </div>

      <div class="sport-event__actions-cancel">
        <div v-if="isUserCreator()">
          <a v-if="sportEvent.is_cancelable" v-on:click.prevent.stop="cancelEvent()" class="text-danger">
            {{ I18n.t("sport_events.show.event_cancel_button")}}
          </a>
        </div>
      </div>
    </div>

    <div class="first-line" v-if="$mq != 'sm'">
      <div class="sport-info">
        <div class="user-sports-wrap">
          <div class="user-sport-item">
            <div class="user-sport-image">
              <div class="sport-item__image" :class="this.sportEvent.sport_code"></div>
              <div class="sport-item__level">
                <div class="sport-item__level-wrap">
                  <span v-for="level in this.sport_event.sport_levels">{{ level }}</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3>{{ I18n.t(`sports.${this.sportEvent.sport_code}`) }}</h3>

            <div class="sport-level-description" v-for="level in this.sport_event.sport_levels">
              {{ I18n.t(`sport_events.levels.${level.toLowerCase()}`) }}
            </div>
          </div>
        </div>
      </div>
      <div class="price-info"></div>

      <div>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div class="price">
            <div v-if="sportEvent.price > 0">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.6 9C10.2 8.9 9.8 8.7 9.5 8.4C9.2 8.3 9.1 8 9.1 7.8C9.1 7.6 9.2 7.3 9.4 7.2C9.7 7 10 6.8 10.3 6.9C10.9 6.9 11.4 7.2 11.7 7.6L12.6 6.4C12.3 6.1 12 5.9 11.7 5.7C11.4 5.5 11 5.4 10.6 5.4V4H9.4V5.4C8.9 5.5 8.4 5.8 8 6.2C7.6 6.7 7.3 7.3 7.4 7.9C7.4 8.5 7.6 9.1 8 9.5C8.5 10 9.2 10.3 9.8 10.6C10.1 10.7 10.5 10.9 10.8 11.1C11 11.3 11.1 11.6 11.1 11.9C11.1 12.2 11 12.5 10.8 12.8C10.5 13.1 10.1 13.2 9.8 13.2C9.4 13.2 8.9 13.1 8.6 12.8C8.3 12.6 8 12.3 7.8 12L6.8 13.1C7.1 13.5 7.4 13.8 7.8 14.1C8.3 14.4 8.9 14.7 9.5 14.7V16H10.6V14.5C11.2 14.4 11.7 14.1 12.1 13.7C12.6 13.2 12.9 12.4 12.9 11.7C12.9 11.1 12.7 10.4 12.2 10C11.7 9.5 11.2 9.2 10.6 9V9ZM10 2C5.6 2 2 5.6 2 10C2 14.4 5.6 18 10 18C14.4 18 18 14.4 18 10C18 5.6 14.4 2 10 2ZM10 16.9C6.2 16.9 3.1 13.8 3.1 10C3.1 6.2 6.2 3.1 10 3.1C13.8 3.1 16.9 6.2 16.9 10C16.9 13.8 13.8 16.9 10 16.9V16.9Z" fill="black"/>
              </svg>

              <span class="price-amount">{{ `${sportEvent.price} ${sportEvent.currency}` }}</span>
              <div class="price-description">за 1 человека</div>
            </div>

            <div v-else>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.6 9C10.2 8.9 9.8 8.7 9.5 8.4C9.2 8.3 9.1 8 9.1 7.8C9.1 7.6 9.2 7.3 9.4 7.2C9.7 7 10 6.8 10.3 6.9C10.9 6.9 11.4 7.2 11.7 7.6L12.6 6.4C12.3 6.1 12 5.9 11.7 5.7C11.4 5.5 11 5.4 10.6 5.4V4H9.4V5.4C8.9 5.5 8.4 5.8 8 6.2C7.6 6.7 7.3 7.3 7.4 7.9C7.4 8.5 7.6 9.1 8 9.5C8.5 10 9.2 10.3 9.8 10.6C10.1 10.7 10.5 10.9 10.8 11.1C11 11.3 11.1 11.6 11.1 11.9C11.1 12.2 11 12.5 10.8 12.8C10.5 13.1 10.1 13.2 9.8 13.2C9.4 13.2 8.9 13.1 8.6 12.8C8.3 12.6 8 12.3 7.8 12L6.8 13.1C7.1 13.5 7.4 13.8 7.8 14.1C8.3 14.4 8.9 14.7 9.5 14.7V16H10.6V14.5C11.2 14.4 11.7 14.1 12.1 13.7C12.6 13.2 12.9 12.4 12.9 11.7C12.9 11.1 12.7 10.4 12.2 10C11.7 9.5 11.2 9.2 10.6 9V9ZM10 2C5.6 2 2 5.6 2 10C2 14.4 5.6 18 10 18C14.4 18 18 14.4 18 10C18 5.6 14.4 2 10 2ZM10 16.9C6.2 16.9 3.1 13.8 3.1 10C3.1 6.2 6.2 3.1 10 3.1C13.8 3.1 16.9 6.2 16.9 10C16.9 13.8 13.8 16.9 10 16.9V16.9Z" fill="black"/>
              </svg>
              <span class="price-amount">{{ I18n.t("sport_events.show.free_price") }}</span>
            </div>
          </div>

          <div class="share-link" v-on:click.prevent.stop="openShareLinkModal()" v-if="['waiting', 'ready'].includes(sportEvent.status) && isUserCreator()">
            <div class="share-link-wrap">
              <a href="" :class="shareLinkClass()">
                <font-awesome-icon icon="link" size="lg" />
                {{ I18n.t("sport_events.share_link.share") }}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div v-if="['waiting', 'ready'].includes(sportEvent.status) && isUserCreator()" class="edit-link" style="margin-top: 24px;">
        <a :href="`/sport_events/${this.sportEvent.id}/edit`" class="btn btn-sm cta-btn edit-button">
           <font-awesome-icon icon="cogs" size="lg" />
           {{ I18n.t("common.buttons.edit2") }}
        </a>
      </div>
    </div>

    <div v-if="showIosAddToHomeScreen" class="ios-bottom-spacer">
      <div class="mobile-logo-sm">
      </div>
      <div style="margin-left: 6px; font-size: 15px;">
        {{ I18n.t("sport_events.ios_add_to_home_screen") }}
      </div>
      <div>
        <button class="btn btn-sm ios-add-to-home-screen-button" @click="openAddIosAppModal()">
          {{ I18n.t("sport_events.ios_add_to_home_screen_button") }}
        </button>
      </div>
      <div class="ios-add-to-home-screen-close">
        <button type="button" class="ios-add-to-home-screen-close-button close" style="font-size: 20px; text-shadow: none; color: black;" data-dismiss="alert" @click="closeIosAddToHomeScreen()">
          &times;
        </button>
      </div>
    </div>

    <modals-container />
  </div>
</template>

<script>
  import axios from "axios"
  import showAlert from "../../utils/alert"
  import requestWebpushSubscription from '../../utils/webpush_subscription'
  import _ from "lodash"
  import showAvatar from "../../utils/avatar"
  import SportEventReviewForm from "../../components/sport_events/modals/review.vue"
  import SportEventPlaceMap from "../../components/sport_events/modals/place_map.vue"
  import SportEventShareLink from "../../components/sport_events/modals/share_link.vue"
  import SportEventRequestWithComment from "../../components/sport_events/modals/first_time_request.vue"
  import SportEventRequestMessage from "../../components/sport_events/modals/request_message.vue"
  import SportEventRejectParticipation from "../../components/sport_events/modals/reject_participation.vue"
  import SportEventRequestIosApp from "../../components/sport_events/modals/add_ios_app.vue"

  const PARTICIPATION_STATUSES = ["waiting", "ready"]
  const BOOKING_STATUSES = ["waiting", "ready"]
  const CHANGEABLE_STATUSES = ["waiting", "ready"]

  export default {
    props: {
      creator: Object,
      user: Object,
      sport_event: Object,
      unread_chat_messages_count: Number,
      is_creator_know_current_user: Boolean,
    },
    data() {
      return {
        participantInActionId: null,
        isShowCommonInfo: null,
        reactedParticipants: [],
        isIos: false,
        showPrompt: false,
        showIosAddToHomeScreen: false,
        sportEvent: this.sport_event,
        validStatuses: ["waiting", "ready", "inprogress", "finished"]
      }
    },
    created() {
      // Add iOS detection
      this.isIOS = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)

      const lastClosedAt = localStorage.getItem('iosAddToHomeScreenClosedAt')
      const twoDaysInMs = 2 * 24 * 60 * 60 * 1000 // 2 days in milliseconds
      this.showPrompt = !lastClosedAt || (new Date() - new Date(lastClosedAt)) > twoDaysInMs

      this.showIosAddToHomeScreen = this.isIOS && ('standalone' in window.navigator) && window.navigator.standalone !== true && this.showPrompt

      requestWebpushSubscription(this.user)

      this.$eventHub.$on("sport-event-link-copied", this.skipSubscribersHighlight);
      this.$eventHub.$on('change-sport-event', this.resetSportEvent);
    },
    mounted() {
      this.$cable.subscribe({ channel: "SportEventChannel", sport_event_id: this.sportEvent.id })
    },
    beforeDestroy() {
      this.$eventHub.$off('change-sport-event');
    },
    channels: {
      SportEventChannel: {
        connected() {
          console.log('I am connected to SportEventChannel.')
        },
        rejected() {},
        received(data) {
          console.log("data received", data)

          if (data) {
            this.sportEvent.share_link_highlight = data.share_link_highlight
          }
        },
        disconnected() {

        }
      }
    },
    methods: {
      sportLevels() {
        return this.sport_event.sport_levels.join(" ")
      },
      creatorProfileLink() {
        return `/users/${this.creator.id}`
      },
      avatarPath(user) {
        return showAvatar(user, 50)
      },
      isUserCreator() {
        return this.creator.id == this.user.id
      },
      canShowParticipantReactions(participant) {
        return this.sportEvent.status == 'finished' &&
               this.participantIds.includes(this.user.id) &&
               this.user.id != participant.id &&
               !_.map(this.sportEvent.reactions, 'for_user_id').includes(participant.id)
      },
      skipSubscribersHighlight(val) {
        this.sportEvent.share_link_highlight = false
      },
      resetSportEvent(emmittedSportEvent) {
        this.sportEvent = emmittedSportEvent
      },
      changeShowCommonInfo(val) {
        this.isShowCommonInfo = val
        setTimeout(() => $('[data-toggle="tooltip"]').tooltip(), 1000);
      },
      participationReject(requestConfirmation = true) {
        let confirmed = true

        if (requestConfirmation) {
          const message = I18n.t("sport_events.show.reject_participation_confirm_message")
          let confirmed = confirm(message)
        }

        if (confirmed) {
          axios
            .post(
              "/api/v1/sport_event_users/participations/reject",
              { sport_event_user: { sport_event_id: this.sportEvent.id } }
            )
            .then(response => {
              showAlert(I18n.t("sport_events.show.notifications.success.participation_rejected"))

              this.sportEvent = response.data["sport_event"]
            })
            .catch(error => {
              showAlert(
                I18n.t("sport_events.show.notifications.failed_participation_reject"),
                "alert"
              )
            })
            .then(() => {
              this.participantInActionId = null
            })
        }
      },
      participationRequest(actionType = "", participant = null) {
        const requestParams = { sport_event_id: this.sportEvent.id }

        // TODO: rewrite this function plz
        if (participant) {
          requestParams["user_id"] = participant.id
          this.participantInActionId = participant.id
        }

        const action = !!actionType ? "accept" : ""

        let successNotificationKey = null

        if (action == "accept") {
          requestParams["action_type"] = actionType
          successNotificationKey = actionType
        } else {
          successNotificationKey = "participation_request_created"
        }

        // TODO: use error messages from response
        axios
          .post(
            `/api/v1/sport_event_users/participations/${action}`,
            { sport_event_user: requestParams }
          )
          .then(response => {
            showAlert(I18n.t(`sport_events.show.notifications.success.${successNotificationKey}`))
            console.log("RESPONSE: ", response.data["sport_event"])
            this.sportEvent = response.data["sport_event"]
          })
          .catch(error => {
            showAlert(
              I18n.t("sport_events.show.notifications.failed_participation_request"),
              "alert"
            )
          })
          .then(() => {
            this.participantInActionId = null
            requestWebpushSubscription(this.user)
          })
      },
      sportEventStartAt() {
        return `${this.sportEvent.start_date_formatted}`
      },
      sportEventStartAtMinutes() {
        const minutes = ('0' + this.sportEvent.start_at_minutes).slice(-2)
        const time = `${this.sportEvent.start_at_hour}:${minutes}`

        return time
      },
      cancelEvent() {
        const message = I18n.t("sport_events.show.cancel_confirm_message")
        const confirmed = confirm(message)

        if (confirmed) {
          axios
            .put(`/api/v1/sport_events/cancels/${this.sportEvent.id}`)
            .then(response => {
              showAlert(I18n.t("sport_events.show.notifications.success_canceled"))

              this.sportEvent = response.data["sport_event"]
            })
            .catch(error => {
              showAlert(
                I18n.t("sport_events.show.notifications.failed_participation_request"),
                "alert"
              )
            })
            .then(() => {
              this.participantInActionId = null
            })
        }
      },
      addReaction(reaction, participantId) {
        axios
            .post(`/api/v1/user_sport_event_reactions/`,
              {
                user_sport_event_reaction: {
                  for_user_id: participantId,
                  sport_event_id: this.sportEvent.id,
                  reaction: reaction
                }
              }
            )
            .then(response => {
              this.sportEvent = response.data["sport_event"]
              this.reactedParticipants.push(participantId)
            })
            .catch(error => {
              console.log(error)
            })
      },
      participantMessage(participantId) {
        return this.sportEvent.participation_requests_messages[participantId]
      },
      logoName(rank) {
        return `${rank}-medal`
      },
      acceptedParticipantsTitleClass(cnt, needCnt) {
        if (cnt < needCnt) {
          return "accepted-less"
        }

        return "accepted-enough"
      },
      fullName(user) {
        if (!user.name && !user.surname) {
          return
        }

        return `${this.user.name ? this.user.name : ''} ${this.user.surname ? this.user.surname : ''}`;
      },
      copyEvent() {
        Turbolinks.visit(`/sport_events/new?sport_event_id=${this.sportEvent.id}`)
      },
      chatLinkHref() {
        return `/messages/${this.sportEvent.chat_uuid}`
      },
      placeCss() {
        if (this.sportEvent.additional_place_info_exists)
          return "place-info-link__address"

        return "place-info-link__address-without-additional-info"
      },
      shareLinkClass() {
        if (this.sportEvent.share_link_highlight)
          return "share-link-red"

        return ""
      },
      participantNicknameColorClass(user) {
        if (user.id == this.sportEvent.creator.id) {
          return "gold-nickname"
        }
      },
      openParticipationWithCommentModal(participantId) {
        this.$modal.show(SportEventRequestWithComment,
          {
            sportEventId: this.sportEvent.id,
            participantId: participantId
          },
          {
            pivotX: (this.$mq === "sm" ? 0 : 0.5),
            width: (this.$mq === "sm" ? "100%" : 600)
          }
        )
      },
      openRejectParticipationModal(participantId) {
        this.$modal.show(SportEventRejectParticipation,
          {
            sportEventId: this.sportEvent.id,
            participantId: participantId
          },
          {
            pivotX: (this.$mq === "sm" ? 0 : 0.5),
            width: (this.$mq === "sm" ? "100%" : 600)
          }
        )
      },
      openRequestMessageModal(text) {
        this.$modal.show(SportEventRequestMessage,
          {
            text: text
          },
          {
            pivotX: (this.$mq === "sm" ? 0 : 0.5),
            width: (this.$mq === "sm" ? "100%" : 600)
          }
        )
      },
      openRejectFromCreatorModal(participantId) {
        this.$modal.show(SportEventRejectFromCreator,
          {
            participantId: participantId,
            sportEventId: this.sportEvent.id
          },
          {
            pivotX: (this.$mq === "sm" ? 0 : 0.5),
            width: (this.$mq === "sm" ? "100%" : 600)
          }
        )
      },
      openPlaceMapModal() {
        this.$modal.show(SportEventPlaceMap,
          {
            sportEventLatitude: this.sportEvent.place_latitude,
            sportEventLongitude: this.sportEvent.place_longitude
          },
          {
            pivotX: (this.$mq === "sm" ? 0 : 0.5),
            width: (this.$mq === "sm" ? "100%" : 600)
          }
        )
      },
      openShareLinkModal() {
        this.$modal.show(SportEventShareLink,
          {
            participation_link: this.sportEvent.participation_link,
            sport_event_id: this.sportEvent.id
          },
          {
            pivotX: (this.$mq === "sm" ? 0 : 0.5),
            width: (this.$mq === "sm" ? "100%" : 600)
          }
        )
      },
      openAddIosAppModal() {
        this.showIosAddToHomeScreen = false
        this.$modal.show(SportEventRequestIosApp,
          {},
          {
            pivotX: (this.$mq === "sm" ? 0 : 0.5),
            width: (this.$mq === "sm" ? "100%" : 600),
            height: "70%"
          }
        )
      },
      closeIosAddToHomeScreen() {
        this.showIosAddToHomeScreen = false

        localStorage.setItem('iosAddToHomeScreenClosedAt', new Date().toISOString())
      }
    },
    computed: {
      isCanBeBooked() {
        return !this.sportEvent.booked &&
                 BOOKING_STATUSES.includes(this.sportEvent.status) &&
                 this.isUserCreator()
      },
      isShowBookingInfo() {
        return BOOKING_STATUSES.includes(this.sportEvent.status)
      },
      isWaitingForParticipants() {
        return PARTICIPATION_STATUSES.includes(this.sportEvent.status)
      },
      requestsFromParticipants() {
        return this.sportEvent.participation_requests
      },
      requestsFromCreator() {
        return this.sportEvent.participants_requests
      },
      acceptedParticipants() {
        return this.sportEvent.accepted_participants
      },
      isUserCanParticipate() {
        return !this.isUserAlreadyParticipant && !this.isUserRequestParticipation &&
               !this.isCreatorMakeRequestForUser && this.isWaitingForParticipants &&
               !this.sportEvent.overlay_other_event && !this.user.is_guest &&
               !this.sportEvent.rejected_participation_request
      },
      isUserRequestParticipation() {
        const requestsFromParticipantsIds = _.map(this.requestsFromParticipants, "id")
        return requestsFromParticipantsIds.includes(this.user.id)
      },
      isUserAlreadyParticipant() {
        return this.participantIds.includes(this.user.id)
      },
      isShowChat() {
        return (
          this.sportEvent.chat_uuid && this.participantIds.includes(this.user.id) ||
                 _.map(this.sportEvent.participants_requests, "id").includes(this.user.id)
        )
      },
      participantIds() {
        return _.map(this.acceptedParticipants, "id")
      },
      canChangeSportEvent() {
        return CHANGEABLE_STATUSES.includes(this.sportEvent.status) &&
                 this.isUserCreator() &&
                 this.sportEvent.can_be_changed
      },
      isCreatorMakeRequestForUser() {
        const requestedParticipantsIds = _.map(this.requestsFromCreator, "id")
        return requestedParticipantsIds.includes(this.user.id)
      },
      statuses() {
        if (this.sportEvent.status == "canceled") {
          return this.sportEvent.ordered_statuses
        } else {
          return this.validStatuses
        }
      },
      isShowCommonInfoDefault() {
        if (this.isShowCommonInfo !== null)
          return this.isShowCommonInfo

        if (this.$mq != 'sm')
          return true

        if (this.isUserAlreadyParticipant)
          return false

        return true
      },
      translatedStatuses() {
        return this.statuses.map(status => {
          return I18n.t(`sport_events.statuses.${status}`)
        })
      },
      currentStatusStep() {
        return this.statuses.indexOf(this.sportEvent.status)
      }
    }
  }
</script>

<style scoped>
  .sport-event {
    padding: 0px 15px;
    padding-top: 80px;

    @media only screen and (max-width: 600px) {
      padding-bottom: 24px;
    }

    @media only screen and (min-width: 600px) {
      display: flex;
    }
  }

  .lg-left-side {
    width: 100%;
    max-width: 610px;
  }

  .user-sports-wrap {
    display: flex;
  }

  .user-sports-wrap h3 {
    font-size: 18px;
    text-transform: lowercase;
    margin-bottom: 6px;
  }

  .user-sport-item {
    margin-right: 18px;
    position: relative;
    /*background-color: #6460AC;*/
    background-color: #7d79b9;
    height: 60px;
    width: 60px;
    border-radius: 10px;
  }

  .sport-item__image {
    height: 30px;
    width: 30px;
    position: absolute;
    top: 15px;
    left: 15px;
  }

  .sport-item__name {
    font-size: 15px;
    font-weight: 500;
  }

  .sport-item__level-wrap {
    min-width: 20px;
    text-align: center;
    padding: 2px;
  }

  .sport-event__competition-results-wrap {
    margin-top: 24px;
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgb(219, 219, 219);
  }

  .sport-event__review-wrap {
    margin-top: 24px;
    text-align: center;

    @media only screen and (min-width: 600px) {
      margin-top: 48px;
    }
  }

  .sport-item__level {
    position: absolute;
    bottom: 1px;
    right: -5px;
    font-size: 11px;
    color: black;
    background-color: #F9DB85;
    font-weight: bold;
    border-radius: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sport-item__level span {
    padding: 1px;
  }

  .sport-level-description {
    font-size: 12px;
    margin-bottom: 3px;
    color: #9b9b9b;
  }

  .badminton {
    background-image: url("../../images/mini-image-badminton.svg");
    background-repeat: no-repeat;
    background-size: 30px 30px;
  }

  .squash {
    background-image: url("../../images/mini-image-squash.svg");
    background-repeat: no-repeat;
    background-size: 30px 30px;
  }

  .football {
    background: url("../../images/mini-image-football.svg");
    background-repeat: no-repeat;
    background-size: 30px 30px;
  }

  .basketball {
    background: url("../../images/mini-image-basketball.svg");
    background-repeat: no-repeat;
    background-size: 30px 30px;
  }

  .tennis {
    background: url("../../images/mini-image-tennis.svg");
    background-repeat: no-repeat;
    background-size: 30px 30px;
  }

  .volleyball {
    background: url("../../images/mini-image-volleyball.svg");
    background-repeat: no-repeat;
    background-size: 30px 30px;
  }

  .tabletennis {
    background: url("../../images/mini-image-tabletennis.svg");
    background-repeat: no-repeat;
    background-size: 30px 30px;
  }

  .datetime-info {
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: 600px) {
      margin-top: 24px;
    }
  }

  .datetime-info-wrap {
    display: flex;
  }

  .datetime-info-img, .place-info-img {
    margin-right: 18px;
  }

  .datetime-info__date-wrap, .place-info__court-address {
    display: flex;
    flex-direction: column;
  }

  .datetime-info__date, .place-info__court {
    font-size: 16px;
    font-weight: 450;

    @media only screen and (max-width: 600px) {
      font-size: 14px;
    }

    @media only screen and (min-width: 600px) {
      display: flex;
      align-items: center;
    }
  }

  .datetime-info__time, .place-info__address {
    font-size: 13px;
    margin-bottom: 3px;
    margin-top: 6px;

    @media only screen and (max-width: 600px) {
      font-size: 12px;
    }
  }

  .datetime-remaining {
    font-size: 12px;
    color: #979797;
    font-weight: 400;

    @media only screen and (max-width: 600px) {
      font-size: 11px;
    }

    @media only screen and (min-width: 600px) {
      margin-left: 12px;
    }
  }

  .edit-link a {
    background: white;
    border: 1px solid #d8d8d8;
    font-size: 13px;
    font-weight: 450;
  }

  /*.datetime-remaining:before {
    display: block;
    content: "";
    position: absolute;
    left: 0;
    top: 7px;
    width: 3px;
    height: 3px;
    border-radius: 100%;
    background: #999;
  }*/

  .place-info {
    margin-top: 24px;
  }

  .place-info-wrap {
    display: flex;
  }

  .place-info-link__address-without-additional-info {
    font-size: 12px;
    color: #679fb3 !important;
    font-weight: 400;
  }

  .place-info-link__address {
    font-weight: 400;
    font-size: 12px;
    margin-bottom: 12px;
  }

  .place-info__court-address {

  }

  .place-info__booking {
    font-size: 12px;
    color: #979797;
    font-weight: 400;

    @media only screen and (max-width: 600px) {
      position: absolute;
      right: 15px;
    }

    @media only screen and (min-width: 600px) {
      margin-left: 12px;
    }
  }

  .place-info__booking--not-booked svg {
    color: #b36798;
    font-size: 12px;
  }

  .price {
    margin-top: 24px;
  }

  .price-amount {
    font-size: 14px;
    font-weight: 450;
  }

  .price-description {
    font-size: 12px;
    color: #979797;

    @media only screen and (max-width: 600px) {
      font-size: 11px;
    }
  }

  .share-link {
    margin-top: 20px;
  }

  .share-link a {
    color: grey;
    text-decoration: none;
    font-weight: 400;
  }

  .share-link a:hover {
    color: #969292;
  }

  .share-link-red {
    color: #a94a4a !important;
  }

  .share-link-red:hover {
    color: #982323;
  }

  .share-link-wrap {
    position: relative;
    display: inline-block;
    font-size: 13px;
  }

  .request-from-creator-info-accept-button-wrap {
    margin-top: 15px;
    margin-bottom: 5px;
  }

  .request-from-creator-info-wrap, .participation-request-wrap, .sport-event__actions--requested-participant, .sport-event__actions--accepted-participant {
    text-align: center;
    margin: 24px 0px;
    font-size: 14px;

    @media only screen and (max-width: 600px) {
      font-size: 13px;
    }
  }

  .sport-event__actions--guest {
    text-align: center;
    margin: 48px 0px;
    font-size: 14px;
  }

  .request-from-creator-info-accept-button-wrap button {
    width: 50%;

    @media only screen and (max-width: 600px) {
      width: 100%;
    }
  }

  .sport-event__actions--requested-participant, .participation-request-wrap {
    background: #f4f6f8;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
  }

  .sport-event__actions--accepted-participant {
    /*border-radius: 10px;
    border: 1px solid green;
    padding: 5px;
    background-color: #f3fff3;
    display: flex;
    align-items: center;*/
  }

  .sport-event__actions--accepted-participant svg {
    margin-right: 6px;
  }

  .participation-request-wrap {

  }

  .sport-event__chat-link-box {
  }

  .sport-event__chat-link-empty-box {
    border-top: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    display: flex;
    justify-content: center;
    position: relative;
  }

  .sport-event__chat-link-box {
    border-top: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    padding: 12px;
  }

  .sport_event__chat-empty-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    padding: 12px;

    @media only screen and (max-width: 600px) {
      font-size: 13px;
    }
  }

  .user-partner-avatar-icon {
    border-radius: 50%;
    width: 50px;
    height: 50px;
  }

  .mobile-chat-link {
    padding: none;
    font-size: 15px !important;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    line-height: 25px !important;
    position: absolute;
    bottom: 12px;
    right: 5px;
    width: 40px;
    height: 40px;
  }

  .mobile-chat-link.purple {
    background-color: #6460ac;
    color: #fff;
  }

  .mobile-chat-link.purple:hover {
    background-color: #5b459c;
  }

  .lg-chat-link {
    position: absolute;
    bottom: 12px;
    right: 5px;
    border-radius: 0.2rem;
  }

  .unread-messages {
    padding: 6px;
    background-color: #7d79b9;
    min-width: 25px;
    color: white;
    border-radius: 20px;
    height: 25px;
    justify-content: center;
    display: flex;
    align-items: center;
    font-size: 13px;
  }

  .paricipants {
    margin-top: 24px;
    padding: 18px;
    font-size: 14px;
    border: 1px solid #dcdcdc;
    border-radius: 12px;

    @media only screen and (max-width: 600px) {
      font-size: 13px;
    }
  }

  .creator-info {
    display: flex;
    width: 100%;
  }

  .accepted-participants {
    margin-top: 24px;
  }

  .accepted-less {
    border-bottom: 2px solid #f9db85;
  }

  .accepted-enough {
    border-bottom: 2px solid green;
  }

  .participation-requests {
    margin-top: 24px;
  }

  .participation-requests a {
    width: 100%;
  }

  .sport-event__actions-cancel {
    margin-top: 24px;
    text-align: center;
  }

  .first-line {
    @media only screen and (min-width: 600px) {
      border-left: 1px solid #dcdcdc;
      height: fit-content;
      max-width: 250px;
      width: 100%;
      margin-left: 24px;
      padding-left: 24px;
    }
  }

  .reject-participation a {
    font-size: 13px;
    cursor: pointer;
  }

  .ios-bottom-spacer {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #602ac1; /* Match your app's background color */
    color: #fff;
    padding: 40px 20px;
    z-index: 10;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }

  .ios-add-to-home-screen-button {
    margin-left: 16px;
    padding: 2px 10px;
    font-size: 15px;
    border-radius: 0.7rem;
    font-weight: 500 !important;
    color: black;
  }

  .ios-add-to-home-screen-close-button {
    position: absolute;
    right: 12px;
    top: 12px;
    font-size: 15px;
  }

  .mobile-logo-sm {
    background: url("../../images/logo.svg");
    background-repeat: no-repeat;
    width: 28px;
    height: 28px;
  }

  /* OLD CSS */
  /*.sport-event {
    font-size: 14px;

    @media only screen and (max-width: 600px) {
      margin-top: 10px;
      padding-bottom: 25px;
      font-size: 13px;
    }
  }*/

  .sport-event button {
    font-size: 13px;
  }

  .sport-event__actions {
    font-size: 14px;
    margin-bottom: 40px;

    @media only screen and (max-width: 600px) {
      font-size: 13px;
      margin-bottom: 20px;
    }
  }

  .sport-event__actions--requested-participant a {
    font-weight: bold;
  }

  .sport-event__actions--not-participant {
    text-align: center;
  }

  .comment {
    margin: 30px 5px;
    line-height: 1.3;
    font-size: 14px;

    @media only screen and (max-width: 600px) {
      font-size: 13px;
      margin-bottom: 10px;
    }
  }

  .show-less-event-info {
  }

  .show-less-event-info a {
    padding: 0px;
    margin-top: 24px;
  }

  .show-less-event-info svg {
    color: #e0a600;
  }

  .show-more-event-info a {
    padding: 0px;
  }

  .show-more-event-info svg {
    color: #e0a600;
  }

  .cta-btn.orange {
    background-color: #feb700;
    color: #fff;
  }

  .cta-btn {
    display: inline-block;
    padding: 2px 8px;
    line-height: 30px;
    text-decoration: none;
    font-size: 12px !important;
    font-weight: 450;
  }

  .cta-btn.orange:hover {
    background-color: #eca215;
    color: #fff;
  }

  .cta-btn.purple {
    background-color: #6460ac;
    color: #fff;
  }

  .cta-btn.purple:hover {
    background-color: #5b459c;
  }

  .btn-large {
    font-size: 0.9rem !important;
    line-height: 1.5 !important;
    padding: 0.375rem 0.75rem !important;
  }

  .gold-nickname {
    color: #f4b60b !important;
  }

  .feedback-status {
    margin: 20px 0px;
    text-align: center;
  }

  .sport-wrap-sm {
    display: flex;
    align-items: flex-end;
  }

  .sport-levels {
    text-align: center;
  }

  .sport-levels strong {
    font-size: 15px;
    color: #3b2c69;
    margin-left: 3px;
  }

  .sport-levels .font-awesome-wrapper {
    color: #4844cc;;
  }

  .sport-image {
    height: 35px;
    width: 35px;

    @media only screen and (max-width: 600px) {
      height: 30px;
      width: 30px;
      margin: auto;
    }
  }

  .participants--title {
    font-size: 16px;
    font-weight: 500;

    @media only screen and (max-width: 600px) {
      font-size: 14px;
    }
  }

  .free {
    background-color: #0c6135 !important;
    color: #fff !important;
    border-radius: 3px;
    padding: 7px;
  }

  .price.center {
    display: flex;
    align-items: center;
  }

  .place-wrap {
    line-height: 1.4;
  }

  .place-name {
    color: #655560;
    font-weight: 450;
    font-size: 13px;

    @media only screen and (max-width: 600px) {
      margin-bottom: 5px;
      font-size: 12px;
    }
  }

  .status-price {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;

    @media only screen and (max-width: 320px) {
      flex-direction: column;
    }
  }

  .step-progress__wrapper {
    margin: 20px 30px;
    margin-bottom: 70px;

    @media only screen and (max-width: 600px) {
      margin-bottom: 10px;
      margin-top: 0px;
    }
  }

  .status-wrap {
    @media only screen and (max-width: 600px) {
      margin-top: -10px;
      margin-bottom: 50px;
    }

    @media only screen and (min-width: 600px) {
      margin-bottom: 40px;
      margin-top: -20px;
    }
  }

  .sport {
    display: flex;
    align-items: flex-end;
  }

  .sport-event__chat-unread-messages {
    position: absolute;
    top: -9px;
    right: -10px;
    background-color: rgba(212, 19, 13, 1);
    color: #fff;
    border-radius: 3px;
    padding: 1px 3px;
    font: 10px Verdana;

    @media only screen and (max-width: 600px) {
      font: 9px Verdana;
      top: -6px;
      right: -11px;
    }
  }

  .header-mob {
    background-color: whitesmoke;
    padding: 15px;
    border-radius: 10px;
  }

  .header-mob--status-waiting {
    background-color: #f3efd5 !important;
  }

  .header-mob--status-ready {
    background-color: #e7f0f5 !important;
  }

  .header-mob--status-inprogress {
    background-color: #eaf5e6 !important;
  }

  .header-mob--status-finished {
    background-color: #edf5ec !important;
  }

  .header-mob--status-canceled {
    background-color: #f3f0f0 !important;
  }

  .sport-event-info--status-waiting {
    @media only screen and (min-width: 600px) {
      background-color: #f3efd5 !important;
    }
  }

  .sport-event-info--status-ready {
    @media only screen and (min-width: 600px) {
      background-color: #e7f0f5 !important;
    }
  }

  .sport-event-info--status-inprogress {
    @media only screen and (min-width: 600px) {
      background-color: #eaf5e6 !important;
    }
  }

  .sport-event-info--status-finished {
    @media only screen and (min-width: 600px) {
      background-color: #edf5ec !important;
    }
  }

  .sport-event-info--status-canceled {
    @media only screen and (min-width: 600px) {
      background-color: #f3f0f0 !important;
    }
  }

  .sport-event-info {
    @media only screen and (min-width: 600px) {
      background-color: whitesmoke;
      padding: 18px;
      border-radius: 10px;
    }
  }

  .sport-and-place {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    align-items: flex-end;

    @media only screen and (max-width: 600px) {
      margin-top: 10px;
    }
  }

  .place {
    font-size: 12px;
    cursor: pointer;
    font-weight: 450;
    border-bottom: 1px dotted #000;

    @media only screen and (max-width: 600px) {
      max-width: 290px;
      font-size: 11px;
    }
  }

  .place svg {
    font-size: 12px;

    @media only screen and (max-width: 600px) {
      font-size: 11px;
    }
  }

  .place-start-at-sport {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media only screen and (min-width: 600px) {
      margin-bottom: 25px;
    }

    @media only screen and (max-width: 600px) {
      line-height: 1.1;
    }
  }

  .place-start-at-sport__place-wrap {
    line-height: 0.7;
  }

  .place-start-at {
    display: flex;
    justify-content: space-between;

    @media only screen and (min-width: 600px) {
      font-size: 14px;
    }

    @media only screen and (max-width: 600px) {
      text-align: center;
    }
  }

  .start-at-price {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;

    @media only screen and (max-width: 600px) {
      margin-bottom: 15px;
    }
  }

  .start-at {
    font-size: 17px;
    font-weight: 500;

    @media only screen and (max-width: 600px) {
      font-size: 15px;
    }
  }

  .start-at a {
    font-size: 13px;
    text-decoration: none;

    @media only screen and (max-width: 600px) {
      font-size: 11px;
    }
  }

  .start-at-text {
    margin-top: -5px;
    font-size: 12px;
    color: grey;

    @media only screen and (max-width: 600px) {
      font-size: 10px;
    }
  }

  .start-at-time {
    margin-top: 8px;
    font-weight: 450;
    font-size: 12px;

    @media only screen and (max-width: 600px) {
      margin-top: 5px;
    }
  }

  .start-at-time a {
    font-weight: 400;
    font-size: 11px;
    text-decoration: none;
    text-transform: lowercase;
  }

  .request-message a {
    cursor: pointer;
  }

  .request-message {
    margin-left: 5px;

    @media only screen and (max-width: 600px) {
      margin-left: 10px;
    }
  }

  .request-message svg {
    width: 15px;
    height: 15px;

    @media only screen and (max-width: 600px) {
      width: 20px;
      height: 20px;
    }
  }
</style>
